// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global variables adn mixins are defined here */
::ng-deep .cdk-global-scrollblock {
  overflow: hidden;
}

::ng-deep mat-pseudo-checkbox {
  width: 0px !important;
}

::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  width: auto !important;
}

::ng-deep .mdc-list-item__primary-text {
  margin: 0px !important;
}

::ng-deep .mdc-tab__ripple {
  display: none;
}

::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled ~ .mdc-checkbox__background {
  background-color: #3e97ff !important;
  border-color: #3e97ff !important;
}

.toaster {
  background-color: #f4f7ff !important;
}

/* variables */
/* MIXINS */
/* mixin for border radius */
/* To create a section at the center of window */
/* To include and adjust background image */
/* to split the input */
/* box-shadow generator
    \$clr- in RGBA format
 */
/*
remove the autofilled background color
*/
/* mixin for create buttons */
/* generate margin & padding */
/* to set the table row */
/* to set the image */
/* to set the styles for first and last child div */
/* to set the font style */
.ast-table .table {
  margin-bottom: 0px;
}
.ast-table table thead th {
  background-color: #edeced;
  border: 1px solid #dee2e6;
  border-top: none !important;
}
.ast-table table td {
  background-color: #fafafa;
  color: #231f20;
  border: 0.5px solid #e2e2e1;
  font-size: 16px;
  font-weight: 500;
  font-family: "Amazon Ember Display Light";
}

/* To create a card at the center */
::ng-deep mat-pseudo-checkbox {
  display: none !important;
}

::ng-deep .mat-calendar-body-selected {
  background-color: #3e97ff !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {
  border-bottom: none !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {
  border-bottom: none !important;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  background-color: #f2f4ff !important;
}

::ng-deep .mat-form-field {
  border: none !important;
}

.dateselect mat-form-field {
  display: flex;
  height: 25px;
  width: 185px;
  font-size: 12px;
  text-align: center;
  height: 24px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin-top: 7px;
  margin-left: 8px;
}
.dateselect mat-form-field mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.dateselect mat-form-field mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.dateselect mat-form-field ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.dateselect mat-form-field mat-label {
  font-size: 12px;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle {
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle button {
  margin-left: 35px;
  width: 20px !important;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

::ng-deep .mat-mdc-form-field-icon-suffix,
[dir=rtl] .mat-mdc-form-field-icon-prefix {
  width: 30px !important;
  margin-top: 10px;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  align-items: center;
  border-radius: 5px;
}

::ng-deep .mat-mdc-icon-button {
  --mat-icon-button-hover-state-layer-opacity: 0 !important;
}

::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {
  display: none;
}

.tab-header ::ng-deep .mat-mdc-tab-list {
  align-content: center;
}
.tab-header ::ng-deep .mat-mdc-tab-links {
  gap: 5px;
}

/** Date Picker **/
::ng-deep mat-datepicker-toggle {
  width: 0 !important;
}
::ng-deep mat-datepicker-toggle button {
  position: absolute;
  /* margin-bottom: -20px; */
  top: -23% !important;
  right: 40px;
}

.date-picker {
  height: 25px;
  min-width: 180px;
  font-size: 12px;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin: 7px 0;
}
.date-picker mat-form-field {
  width: 210px;
}
.date-picker ::ng-deep .mdc-text-field {
  padding-left: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  padding: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex {
  height: 23px;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {
  width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}
.date-picker mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-inner {
  letter-spacing: 0.5px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-container {
  justify-content: center;
  font-family: "Poppins";
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 10px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-end-wrapper {
  flex-grow: initial !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-wrapper {
  width: 70px;
}
.date-picker mat-label {
  font-size: 12px;
}
.date-picker ::ng-deep mat-datepicker-toggle button {
  width: 24px !important;
  height: 24px !important;
  padding: 0 !important;
  transform: translateX(10px);
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
  background-position: center;
}
.date-picker ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

/** Date Picker **/
.back-button,
.close-button {
  width: 35px;
  height: 35px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: all 0.25s;
}

.back-button {
  background-image: url('back.svg');
}
.back-button:hover {
  background-image: url('back-hover.svg');
}

.close-button {
  background-image: url('close-circle.svg');
}
.close-button:hover {
  background-image: url('close-cirlce-hover.svg');
}

/* Global variables adn mixins are defined here */
::ng-deep .cdk-global-scrollblock {
  overflow: hidden;
}

::ng-deep mat-pseudo-checkbox {
  width: 0px !important;
}

::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  width: auto !important;
}

::ng-deep .mdc-list-item__primary-text {
  margin: 0px !important;
}

::ng-deep .mdc-tab__ripple {
  display: none;
}

::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled ~ .mdc-checkbox__background {
  background-color: #3e97ff !important;
  border-color: #3e97ff !important;
}

.toaster {
  background-color: #f4f7ff !important;
}

/* variables */
/* MIXINS */
/* mixin for border radius */
/* To create a section at the center of window */
/* To include and adjust background image */
/* to split the input */
/* box-shadow generator
    \$clr- in RGBA format
 */
/*
remove the autofilled background color
*/
/* mixin for create buttons */
/* generate margin & padding */
/* to set the table row */
/* to set the image */
/* to set the styles for first and last child div */
/* to set the font style */
.ast-table .table {
  margin-bottom: 0px;
}
.ast-table table thead th {
  background-color: #edeced;
  border: 1px solid #dee2e6;
  border-top: none !important;
}
.ast-table table td {
  background-color: #fafafa;
  color: #231f20;
  border: 0.5px solid #e2e2e1;
  font-size: 16px;
  font-weight: 500;
  font-family: "Amazon Ember Display Light";
}

/* To create a card at the center */
::ng-deep mat-pseudo-checkbox {
  display: none !important;
}

::ng-deep .mat-calendar-body-selected {
  background-color: #3e97ff !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {
  border-bottom: none !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {
  border-bottom: none !important;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  background-color: #f2f4ff !important;
}

::ng-deep .mat-form-field {
  border: none !important;
}

.dateselect mat-form-field {
  display: flex;
  height: 25px;
  width: 185px;
  font-size: 12px;
  text-align: center;
  height: 24px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin-top: 7px;
  margin-left: 8px;
}
.dateselect mat-form-field mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.dateselect mat-form-field mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.dateselect mat-form-field ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.dateselect mat-form-field mat-label {
  font-size: 12px;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle {
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle button {
  margin-left: 35px;
  width: 20px !important;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

::ng-deep .mat-mdc-form-field-icon-suffix,
[dir=rtl] .mat-mdc-form-field-icon-prefix {
  width: 30px !important;
  margin-top: 10px;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  align-items: center;
  border-radius: 5px;
}

::ng-deep .mat-mdc-icon-button {
  --mat-icon-button-hover-state-layer-opacity: 0 !important;
}

::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {
  display: none;
}

.tab-header ::ng-deep .mat-mdc-tab-list {
  align-content: center;
}
.tab-header ::ng-deep .mat-mdc-tab-links {
  gap: 5px;
}

/** Date Picker **/
::ng-deep mat-datepicker-toggle {
  width: 0 !important;
}
::ng-deep mat-datepicker-toggle button {
  position: absolute;
  /* margin-bottom: -20px; */
  top: -23% !important;
  right: 40px;
}

.date-picker {
  height: 25px;
  min-width: 180px;
  font-size: 12px;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin: 7px 0;
}
.date-picker mat-form-field {
  width: 210px;
}
.date-picker ::ng-deep .mdc-text-field {
  padding-left: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  padding: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex {
  height: 23px;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {
  width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}
.date-picker mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-inner {
  letter-spacing: 0.5px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-container {
  justify-content: center;
  font-family: "Poppins";
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 10px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-end-wrapper {
  flex-grow: initial !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-wrapper {
  width: 70px;
}
.date-picker mat-label {
  font-size: 12px;
}
.date-picker ::ng-deep mat-datepicker-toggle button {
  width: 24px !important;
  height: 24px !important;
  padding: 0 !important;
  transform: translateX(10px);
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
  background-position: center;
}
.date-picker ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

/** Date Picker **/
.back-button,
.close-button {
  width: 35px;
  height: 35px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: all 0.25s;
}

.back-button {
  background-image: url('back.svg');
}
.back-button:hover {
  background-image: url('back-hover.svg');
}

.close-button {
  background-image: url('close-circle.svg');
}
.close-button:hover {
  background-image: url('close-cirlce-hover.svg');
}

/* Global variables adn mixins are defined here */
::ng-deep .cdk-global-scrollblock {
  overflow: hidden;
}

::ng-deep mat-pseudo-checkbox {
  width: 0px !important;
}

::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  width: auto !important;
}

::ng-deep .mdc-list-item__primary-text {
  margin: 0px !important;
}

::ng-deep .mdc-tab__ripple {
  display: none;
}

::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled ~ .mdc-checkbox__background {
  background-color: #3e97ff !important;
  border-color: #3e97ff !important;
}

.toaster {
  background-color: #f4f7ff !important;
}

/* variables */
/* MIXINS */
/* mixin for border radius */
/* To create a section at the center of window */
/* To include and adjust background image */
/* to split the input */
/* box-shadow generator
    \$clr- in RGBA format
 */
/*
remove the autofilled background color
*/
/* mixin for create buttons */
/* generate margin & padding */
/* to set the table row */
/* to set the image */
/* to set the styles for first and last child div */
/* to set the font style */
.ast-table .table {
  margin-bottom: 0px;
}
.ast-table table thead th {
  background-color: #edeced;
  border: 1px solid #dee2e6;
  border-top: none !important;
}
.ast-table table td {
  background-color: #fafafa;
  color: #231f20;
  border: 0.5px solid #e2e2e1;
  font-size: 16px;
  font-weight: 500;
  font-family: "Amazon Ember Display Light";
}

/* To create a card at the center */
::ng-deep mat-pseudo-checkbox {
  display: none !important;
}

::ng-deep .mat-calendar-body-selected {
  background-color: #3e97ff !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {
  border-bottom: none !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {
  border-bottom: none !important;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  background-color: #f2f4ff !important;
}

::ng-deep .mat-form-field {
  border: none !important;
}

.dateselect mat-form-field {
  display: flex;
  height: 25px;
  width: 185px;
  font-size: 12px;
  text-align: center;
  height: 24px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin-top: 7px;
  margin-left: 8px;
}
.dateselect mat-form-field mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.dateselect mat-form-field mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.dateselect mat-form-field ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.dateselect mat-form-field mat-label {
  font-size: 12px;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle {
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle button {
  margin-left: 35px;
  width: 20px !important;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

::ng-deep .mat-mdc-form-field-icon-suffix,
[dir=rtl] .mat-mdc-form-field-icon-prefix {
  width: 30px !important;
  margin-top: 10px;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  align-items: center;
  border-radius: 5px;
}

::ng-deep .mat-mdc-icon-button {
  --mat-icon-button-hover-state-layer-opacity: 0 !important;
}

::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {
  display: none;
}

.tab-header ::ng-deep .mat-mdc-tab-list {
  align-content: center;
}
.tab-header ::ng-deep .mat-mdc-tab-links {
  gap: 5px;
}

/** Date Picker **/
::ng-deep mat-datepicker-toggle {
  width: 0 !important;
}
::ng-deep mat-datepicker-toggle button {
  position: absolute;
  /* margin-bottom: -20px; */
  top: -23% !important;
  right: 40px;
}

.date-picker {
  height: 25px;
  min-width: 180px;
  font-size: 12px;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin: 7px 0;
}
.date-picker mat-form-field {
  width: 210px;
}
.date-picker ::ng-deep .mdc-text-field {
  padding-left: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  padding: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex {
  height: 23px;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {
  width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}
.date-picker mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-inner {
  letter-spacing: 0.5px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-container {
  justify-content: center;
  font-family: "Poppins";
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 10px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-end-wrapper {
  flex-grow: initial !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-wrapper {
  width: 70px;
}
.date-picker mat-label {
  font-size: 12px;
}
.date-picker ::ng-deep mat-datepicker-toggle button {
  width: 24px !important;
  height: 24px !important;
  padding: 0 !important;
  transform: translateX(10px);
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
  background-position: center;
}
.date-picker ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

/** Date Picker **/
.back-button,
.close-button {
  width: 35px;
  height: 35px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: all 0.25s;
}

.back-button {
  background-image: url('back.svg');
}
.back-button:hover {
  background-image: url('back-hover.svg');
}

.close-button {
  background-image: url('close-circle.svg');
}
.close-button:hover {
  background-image: url('close-cirlce-hover.svg');
}

.no-margin {
  margin-left: 0px;
}
.no-margin mat-select {
  padding: 3px !important;
}

.inactiveFlag {
  padding: 0px;
}
.inactiveFlag form {
  display: flex;
  justify-content: right;
}
.inactiveFlag .searchText {
  width: 210px;
}

.tab-header {
  border-bottom: none;
  height: 70px;
  padding-left: 10px;
}

::ng-deep .main-content .content {
  padding: 0px !important;
}

::ng-deep .mat-ripple .mat-mdc-tab-header-pagination .mat-mdc-tab-header-pagination-before .mat-mdc-tab-header-pagination-disabled {
  display: none !important;
}

::ng-deep .mat-mdc-tab-header-pagination-controls-enabled .mat-mdc-tab-header-pagination {
  display: none !important;
}

::ng-deep .mat-pseudo-checkbox-checked.mat-pseudo-checkbox-minimal::after,
.mat-pseudo-checkbox-indeterminate.mat-pseudo-checkbox-minimal::after {
  color: #3e97ff;
}

::ng-deep .mdc-list-item--selected .mdc-list-item__primary-text,
.mdc-list-item--activated .mdc-list-item__primary-text {
  color: #3e97ff;
}

::ng-deep .mat-mdc-select-value-text {
  color: #959cbd;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
}

::ng-deep .mat-mdc-select-arrow-wrapper {
  display: none !important;
}

.create-action {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 0;
  line-height: 15.5px;
  text-align: left;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 300;
  height: 31px;
  min-width: 100px;
  background: #3e97ff;
  color: #ffffff;
  position: relative;
  text-align: center;
  margin: 0px 7px !important;
  border: none !important;
  position: relative;
  overflow: hidden;
  transition: background 0.5s;
}
.create-action:disabled {
  cursor: not-allowed;
}
.create-action:focus {
  outline: none;
}
.create-action:hover, .create-action:focus, .create-action:active {
  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
  text-decoration: none;
}
.create-action:hover, .create-action:focus, .create-action:active {
  background: #3e97ff;
  color: #ffffff;
  border: 1px solid #3e97ff;
}
.create-action span {
  color: #ffffff;
  position: relative;
  z-index: 10000;
  padding-left: 2px;
}
.create-action img {
  position: relative;
  z-index: 10000;
  margin-bottom: 3px;
  width: 12px;
}

.create-action::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #1e2238, #1e2238);
  transition: left 0.5s;
}

.create-action:hover::before {
  left: 0;
}

::ng-deep .mat-mdc-tab-header.mat-mdc-tab-nav-bar-stretch-tabs .mat-mdc-tab-link {
  flex-grow: 0 !important;
}

.tab-header ::ng-deep .mat-mdc-tab-link {
  padding: 0 10px;
}

.topClass {
  position: fixed;
  z-index: 10;
  top: 80px;
  min-height: 40px;
  width: 100%;
}

.download {
  margin-left: 8px !important;
}

.allFlags {
  width: 24px;
  margin-left: -3px;
}

.siteClass {
  margin-left: 10px !important;
}

.layout-header {
  background-color: #ffffff;
  overflow-y: hidden;
  margin: 0px !important;
  overflow-x: hidden;
}

.layout {
  margin: 20px;
  margin-top: 60px;
  background: #ffffff;
  gap: 12px;
}

.head {
  color: #3f4254;
  font-size: 14px;
  font-weight: 500;
  padding: 0 20px;
  margin: 10px 0;
}

.vertical-line {
  border-right: 1px solid gainsboro;
}

.right-header {
  display: flex;
  justify-content: flex-end;
  padding: 0 20px;
}

.rightDiv {
  display: flex;
  gap: 8px;
}

.selectClass {
  font-size: 12px !important;
  margin: 7px 0px;
  background-color: #f2f4ff;
  border-radius: 5px;
  width: 140px;
  text-align: center;
}

.report {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f2f4ff;
  border-radius: 5px;
  height: 25.5px;
  text-align: center;
  padding: 0 20px;
  margin: 7px 0;
}
.report p {
  font-size: 12px;
  color: #959cbd;
  text-align: center;
}
.report div {
  width: 18px;
  height: 18px;
  background-image: url('report-download.svg');
  background-repeat: no-repeat;
  background-position: center;
}

.tabs {
  background-color: #ffffff;
  margin: 20px;
  margin-top: 60px;
  margin-left: 20px !important;
  margin-right: 20px !important;
  padding: 10px;
  margin-bottom: 70px;
}

.headerTab {
  padding: 20px;
  padding-top: 0px;
}

::ng-deep .mdc-tab__text-label {
  font-size: 16px !important;
  letter-spacing: 0px;
  color: #181c32 !important;
  font-family: "Poppins", sans-serif;
}

.tab-label:hover {
  color: #3e97ff;
}

.tab-active {
  border-bottom: 2px solid #3e97ff;
}
.tab-active .tab-label {
  color: #3e97ff;
}

.redFlag {
  color: #3e97ff;
  border-bottom: 2px solid #3e97ff;
}
.redFlag .tab-label {
  color: #3e97ff;
}

.toolbar {
  background-color: #ffffff;
}
.toolbar mat-toolbar-row {
  padding: 0px;
}
.toolbar nav a {
  padding: 0px 8px;
}
.toolbar nav .history {
  margin-left: 4px;
}

.searchText {
  display: flex;
  align-items: center;
  border: 1px solid #e1e3ea;
  border-radius: 5px;
}
.searchText input {
  border: none;
}

.searchImg {
  width: 20px;
  height: 15px;
  padding-left: 5px;
}

.searchFlag {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
}
.searchFlag .search {
  width: 30%;
}
.searchFlag .search .searchText input,
.searchFlag .search .searchText input::placeholder {
  font-size: 12px;
  color: #959cbd;
  font-family: "Poppins";
}
.searchFlag .search .searchText input {
  border-color: #f1f1f2;
  box-shadow: none !important;
}
.searchFlag .flag {
  display: grid;
  justify-content: left;
  margin-left: 18px;
}

::ng-deep .mat-mdc-option .mat-pseudo-checkbox-minimal {
  width: 6px !important;
}

.logClass {
  font-size: 12px !important;
  padding: 5px 10px !important;
  width: 220px;
  text-align: center;
  background-repeat: no-repeat;
  background-position: calc(100% - 3px), calc(0% + 8px);
  background-size: 18px;
  background-color: #f2f4ff;
  border: none;
  color: #959cbd;
  box-shadow: none !important;
  border-radius: 5px;
}

.flagClass {
  font-size: 12px !important;
  padding: 5px 0px !important;
  width: 150px;
  text-align: center;
  background-repeat: no-repeat;
  background-position: calc(100% - 3px), calc(0% + 8px);
  background-size: 18px;
  background-color: #f2f4ff;
  border: none;
  color: #959cbd;
  box-shadow: none !important;
  border-radius: 5px;
}

.option {
  font-size: 12px !important;
  padding-left: 10px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
}
.option:active {
  color: #3e97ff !important;
}
.option:hover {
  color: #3e97ff;
}
.option span {
  padding-left: 8px;
}
.option img {
  width: 17px;
}

.redflagClass {
  font-size: 12px !important;
  padding: 10px 12px !important;
  text-align: center;
  background-size: 25px 15px !important;
  --bs-form-select-bg-img: url('flag-dropdown.svg'),
    url('flag-red.svg');
  background-position: right, left;
  background-size: 30px;
  background-color: #f2f4ff;
  border: none;
  color: #959cbd;
  box-shadow: none !important;
}

::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}

.mat-icon {
  height: 30px;
}
.mat-icon img {
  width: 17px;
}

.custom-mat-form-field {
  width: 50%;
  height: 50px;
}

.input {
  height: 50%;
  margin: 7px 0px;
  width: 120px;
  background: #f2f4ff;
  border: none;
  font-size: 12px;
  color: #959cbd;
  border-radius: 5px;
}
.input:focus {
  outline: none;
}

.input::placeholder {
  color: #959cbd;
  padding-left: 10px;
}

::ng-deep .ngx-pagination li {
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  border-radius: 5px !important;
  margin: 0px 15px;
}
::ng-deep .ngx-pagination li a {
  color: #959cbd !important;
}

::ng-deep .ngx-pagination li :hover {
  border-radius: 5px !important;
  color: #ffffff !important;
  background-color: #3e97ff !important;
}

::ng-deep .ngx-pagination li:not(:last-child) {
  background-color: #f1f1f2 !important;
}

::ng-deep .ngx-pagination li.current {
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  background-color: #3e97ff !important;
  color: #ffffff !important;
  cursor: pointer;
}

.date-pickder {
  height: 25px;
}

.dateClass {
  width: 180px;
  font-size: 12px;
  text-align: center;
  height: 24px;
  color: #959cbd;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin-top: 7px;
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
  background-position: 155px;
  background-color: #f2f4ff;
  cursor: pointer;
  border: none;
  outline: none;
  border-radius: 5px;
  padding-right: 25px;
  margin-left: 8px;
}

::ng-deep .mat-form-field-type-mat-date-range-input .mat-form-field-infix {
  display: flex;
}

::ng-deep .mat-date-range-input-start-wrapper {
  width: 32%;
}

::ng-deep .md-drppicker.ltr {
  position: fixed;
  color: #181c32;
  padding: 10px;
}

::ng-deep .md-drppicker .ranges ul li button.active {
  background-color: #3e97ff !important;
  border-radius: 5px;
}

::ng-deep .md-drppicker td.active,
.md-drppicker td.active:hover {
  background-color: #3e97ff !important;
}

::ng-deep .md-drppicker .calendar th span,
.md-drppicker .calendar td span {
  color: #181c32 !important;
}

::ng-deep .md-drppicker th.month {
  color: #181c32;
}

::ng-deep .buttons_input .btn {
  background-color: #3e97ff !important;
}
::ng-deep .buttons_input .btn-default {
  background-color: #dcdcdc !important;
  margin-right: 15px;
}

.myDatePicker ::ng-deep ngx-daterangepicker-material .md-drppicker {
  height: 300px;
  overflow: auto;
  top: 125px !important;
}
.myDatePicker ::ng-deep ngx-daterangepicker-material .md-drppicker .ranges ul li {
  border-radius: 5px;
}
.myDatePicker ::ng-deep ngx-daterangepicker-material .md-drppicker .ranges ul li:hover {
  background-color: #3e97ff;
}
.myDatePicker ::ng-deep ngx-daterangepicker-material .md-drppicker .ranges ul li button:hover {
  color: #ffffff;
}

::ng-deep .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled) .mdc-list-item__primary-text {
  color: #3e97ff !important;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
}

::ng-deep .mat-mdc-option .mat-pseudo-checkbox-minimal {
  margin: 0px !important;
}

::ng-deep .mat-mdc-tab-link-container {
  overflow: auto !important;
}

.tab-navbar {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

@media (max-width: 1024px) {
  .tab-navbar {
    flex-direction: column;
  }
}
@media (max-width: 540px) {
  .rightDiv {
    overflow-x: auto;
  }
  .search {
    width: 100% !important;
  }
  ::ng-deep ngx-daterangepicker-material .md-drppicker {
    left: 60px !important;
    top: 160px !important;
  }
}
@media (width: 540px) {
  ::ng-deep ngx-daterangepicker-material .md-drppicker {
    left: 200px !important;
  }
  .rightHeader {
    justify-content: center !important;
  }
}
@media (max-width: 768px) {
  .layout {
    margin-top: 95px;
  }
  .right-header {
    padding: 0 10px;
  }
}
@media (max-width: 290px) {
  .toolbar {
    overflow-x: auto;
  }
  .searchFlag {
    display: block;
  }
  .search {
    padding: 15px 0px;
  }
  .flag {
    display: block !important;
    text-align: right;
  }
}
@media (min-width: 769px) and (max-width: 830px) {
  .rightDiv {
    overflow-x: auto;
  }
}
@media (min-width: 700px) {
  ::ng-deep ngx-daterangepicker-material .md-drppicker {
    left: calc(100% - 630px) !important;
  }
}
@media (width: 280px) {
  ::ng-deep ngx-daterangepicker-material .md-drppicker {
    left: 9px !important;
  }
}
@media screen and (max-width: 767px) {
  ::ng-deep .mat-mdc-tab-link-container {
    overflow: auto !important;
  }
  ::ng-deep .mat-mdc-tab-nav-bar {
    width: 100% !important;
  }
}
.tabs {
  background-color: #ffffff;
  margin: 20px;
  margin-left: 20px !important;
  margin-right: 20px !important;
  padding: 10px;
}

.searchText {
  display: flex;
  align-items: center;
  border: 1px solid #e1e3ea;
  border-radius: 5px;
}
.searchText input {
  border: none;
}

.searchImg {
  width: 20px;
  height: 15px;
  padding-left: 5px;
}

.hideButton {
  z-index: -1;
}

::ng-deep .mat-mdc-menu-content :hover,
.mat-mdc-menu-content .mat-mdc-menu-item .mat-mdc-menu-item-text :hover {
  color: #3e97ff !important;
  background-color: #f2f4ff;
}

::ng-deep .mdc-tab__text-label {
  font-size: 16px !important;
  letter-spacing: 0px;
  color: #181c32 !important;
  font-family: "Poppins", sans-serif;
}

.tab-label:hover {
  color: #3e97ff;
}

.topClass {
  position: fixed;
  z-index: 10;
  top: 80px;
  width: 100%;
}

.layout-header {
  display: flex;
  justify-content: space-between;
  background-color: #ffffff;
  overflow-y: hidden;
  margin: 0px !important;
  overflow-x: hidden;
}
.layout-header .back-icon {
  margin-top: 12px;
  margin-left: 10px;
}

.tab-header {
  border-bottom: none;
  height: 70px;
  padding-left: 10px;
}
.tab-header a {
  padding: 0px;
  width: 0px;
  text-decoration: none;
}
.tab-header a:hover {
  color: #3e97ff;
}
.tab-header .tab-active {
  border-bottom: 2px solid #3e97ff;
}
.tab-header .tab-active .tab-label {
  color: #3e97ff;
}
.tab-header .mat-tab-link {
  min-width: 110px !important;
  margin-top: 10px;
  padding: 0;
  font-size: 18px;
  font-weight: 700;
  opacity: 0.5;
}

.layout-panel {
  height: calc(100vh - 170px);
  overflow: auto;
}
.layout-panel > div {
  margin: 20px;
  padding: 0 10px;
  background: #ffffff;
}
@media (max-width: 576px) {
  .layout-panel {
    height: calc(100vh - 207px);
  }
}

.tab-body {
  top: 20px;
}

.material-icons {
  vertical-align: middle;
  margin-left: 25px;
  font-size: 30px;
}

.create-action {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 0;
  line-height: 15.5px;
  text-align: left;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 300;
  height: 31px;
  min-width: 100px;
  background: #3e97ff;
  color: #ffffff;
  position: relative;
  text-align: center;
  border: none !important;
  position: relative;
  overflow: hidden;
  transition: background 0.5s;
  margin: 0px !important;
}
.create-action:disabled {
  cursor: not-allowed;
}
.create-action:focus {
  outline: none;
}
.create-action:hover, .create-action:focus, .create-action:active {
  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
  text-decoration: none;
}
.create-action:hover, .create-action:focus, .create-action:active {
  background: #3e97ff;
  color: #ffffff;
  border: 1px solid #3e97ff;
}
.create-action span {
  color: #ffffff;
  position: relative;
  z-index: 9;
  padding-left: 2px;
}
.create-action img {
  margin-left: 0px !important;
  width: 12px;
  margin-bottom: 1px !important;
  z-index: 9;
  position: relative;
}

.create-action::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #1e2238, #1e2238);
  transition: left 0.5s;
}

.create-action:hover::before {
  left: 0;
}

.delete-action {
  width: 100%;
  background: #ff4b55;
}
.delete-action img {
  width: 15px;
  height: 15px;
  transform: translateY(-1.5px);
  margin: 0;
}
.delete-action:hover, .delete-action:focus, .delete-action:active {
  background: #ff4b55;
  color: #ffffff;
  border: 1px solid #ff4b55;
}

.deletecount {
  width: 100%;
  text-align: center;
  color: #ff4b55;
  background-color: #fff5f8;
  padding: 6px 12px;
  border-radius: 5px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 13px;
}

.searchFlag {
  gap: 12px;
  padding-right: 10px;
}

.search {
  width: 100% !important;
}

.buttonsClass {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.rightHeader {
  justify-content: flex-end;
}

.vendor {
  margin-right: 7px;
}

@media (max-width: 768px) {
  .layout {
    margin-top: 95px !important;
  }
}
@media (max-width: 560px) {
  .layout-header {
    flex-direction: column;
  }
}
@media (max-width: 452px) {
  .searchFlag {
    flex-direction: column;
  }
  .buttonsClass,
  .create-action {
    width: 100%;
  }
}
.icon {
  padding-right: 5px;
}

::ng-deep .mat-mdc-tab-links {
  width: 0px;
}

a:hover {
  background-color: #f2f4ff !important;
}
a:hover ::ng-deep .mdc-tab__text-label {
  color: #3e97ff !important;
}

.cancel-action {
  display: inline-block;
  margin-bottom: 0;
  line-height: 15.5px;
  text-align: left;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 300;
  height: 31px;
  min-width: 100px;
  background: #e1e3ea;
  color: #959cbd;
  position: relative;
  text-align: center;
  margin-right: 10px;
  border: none !important;
  position: relative;
  overflow: hidden;
  transition: background 0.5s;
}
.cancel-action:disabled {
  cursor: not-allowed;
}
.cancel-action:focus {
  outline: none;
}
.cancel-action:hover, .cancel-action:focus, .cancel-action:active {
  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
  text-decoration: none;
}
.cancel-action:hover, .cancel-action:focus, .cancel-action:active {
  background: #e1e3ea;
  color: #959cbd;
  border: 1px solid #e1e3ea;
}
.cancel-action span {
  color: #ffffff;
  position: relative;
  z-index: 9;
  padding-left: 2px;
}

.cancel-action::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #1e2238, #1e2238);
  transition: left 0.5s;
}

.cancel-action:hover::before {
  left: 0;
}

::ng-deep .mat-mdc-tab-link.mdc-tab--active .mdc-tab__text-label {
  color: #3e97ff !important;
}

::ng-deep .mat-mdc-tab-link .mdc-tab__text-label:hover {
  color: #3e97ff !important;
}

::ng-deep .mat-mdc-tab-link .mdc-tab-indicator__content--underline {
  border-color: #3e97ff !important;
}

.searchText {
  display: flex;
  align-items: center;
  border: 1px solid #e1e3ea;
  border-radius: 5px;
}
.searchText input {
  border: none;
}

.downloadUser {
  margin-left: 120px !important;
}

.notChecked {
  margin-left: 300px !important;
}

.searchImg {
  width: 20px;
  height: 15px;
  padding-left: 5px;
}

.my-profile-container {
  height: 100%;
  font-family: "Poppins";
  padding: 0px;
}
.my-profile-container .row {
  background-color: #ffffff;
  padding: 30px;
}
.my-profile-container .row .profile-container {
  border-bottom: 1px solid #dbd8d8;
  padding-bottom: 20px;
}
.my-profile-container .row .profile-container .profile .profile-logo {
  float: left;
}
.my-profile-container .row .profile-container .profile .profile-logo .logo {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  width: 150px;
  background-color: #f3f6f9;
  font-size: 90px;
  font-weight: 500;
  color: #7b8fa1;
  border-radius: 8px;
  border: none;
}
.my-profile-container .row .profile-container .profile .profile-logo ::ng-deep .mat-badge-small.mat-badge-overlap.mat-badge-after .mat-badge-content {
  right: -8px;
  top: 100px;
  color: transparent;
  background-color: #50cd89;
}
.my-profile-container .row .profile-container .profile .profile-info {
  font-family: "Poppins", sans-serif;
  padding-left: 30px;
  color: #707070;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: stretch;
}
.my-profile-container .row .profile-container .profile .profile-info .user-data {
  display: flex;
  justify-content: space-between;
}
.my-profile-container .row .profile-container .profile .profile-info .user-data .name {
  color: #3f4254;
  font-size: 16px;
  font-weight: 600;
}
.my-profile-container .row .profile-container .profile .profile-info .user-data .name span .patch-superadmin,
.my-profile-container .row .profile-container .profile .profile-info .user-data .name span patch-SuperAdminRead {
  filter: invert(51%) sepia(70%) saturate(3192%) hue-rotate(196deg) brightness(105%) contrast(102%);
}
.my-profile-container .row .profile-container .profile .profile-info .user-data .name span .patch-Vendoradmin {
  filter: invert(70%) sepia(60%) saturate(4215%) hue-rotate(101deg) brightness(95%) contrast(62%);
}
.my-profile-container .row .profile-container .profile .profile-info .user-data .name span .patch-fielduser {
  filter: invert(66%) sepia(81%) saturate(517%) hue-rotate(6deg) brightness(102%) contrast(96%);
}
.my-profile-container .row .profile-container .profile .profile-info .user-data .name span .patch-Site {
  filter: invert(66%) sepia(81%) saturate(517%) hue-rotate(6deg) brightness(102%) contrast(96%);
}
.my-profile-container .row .profile-container .profile .profile-info .user-data .name span img path {
  fill: #3e97ff;
}
.my-profile-container .row .profile-container .profile .profile-info .user-data .user-info {
  display: flex;
  gap: 10px;
}
.my-profile-container .row .profile-container .profile .profile-info .user-data .user-info .org {
  font-size: 12px;
}
.my-profile-container .row .profile-container .profile .profile-info .user-data .user-info .phone {
  font-size: 12px;
}
.my-profile-container .row .profile-container .profile .profile-info .user-data .user-info .fa-user {
  margin-right: 5px;
}
.my-profile-container .row .profile-container .profile .profile-info .user-data .user-info .fa-map-marker {
  margin-right: 5px;
}
.my-profile-container .row .profile-container .profile .profile-info .user-data .user-info .fa-phone {
  margin-right: 5px;
}
.my-profile-container .row .profile-container .profile .profile-info .user-data .user-info .location {
  font-size: 12px;
}
.my-profile-container .row .profile-container .profile .profile-info .count-data {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.my-profile-container .row .profile-container .profile .profile-info .count-data .count-info {
  display: flex;
}
.my-profile-container .row .profile-container .profile .profile-info .count-data .count-info .onboarding-count {
  width: 150px;
  padding: 10px 0px;
  text-align: center;
  border: 1px dashed #cfcfcf;
  border-radius: 5px;
}
.my-profile-container .row .profile-container .profile .profile-info .count-data .count-info .onboarding-count .count {
  font-size: 16px;
  font-weight: 500;
  color: #181c32;
}
.my-profile-container .row .profile-container .profile .profile-info .count-data .count-info .onboarding-count .name {
  font-size: 12px;
  color: #707070;
}
.my-profile-container .row .profile-container .profile .profile-info .count-data .count-info .red-flag-count {
  margin-left: 20px;
  width: 150px;
  padding: 10px 0px;
  text-align: center;
  border: 1px dashed #cfcfcf;
  border-radius: 5px;
}
.my-profile-container .row .profile-container .profile .profile-info .count-data .count-info .red-flag-count .count {
  font-size: 16px;
  font-weight: 500;
  color: #181c32;
}
.my-profile-container .row .profile-container .profile .profile-info .count-data .count-info .red-flag-count .name {
  font-size: 12px;
  color: #707070;
}
.my-profile-container .row .profile-container .profile .profile-info .count-data .progress-card {
  width: 250px;
  font-size: 12px;
  box-shadow: none;
}
.my-profile-container .row .profile-container .profile .profile-info .count-data .progress-card .progress-content .progress-info {
  display: flex;
  justify-content: space-between;
}
.my-profile-container .row .profile-container .profile .profile-info .count-data .progress-card .progress-content .progress-info .active {
  font-weight: 600;
  color: #181c32 !important;
}
.my-profile-container .row .profile-container .profile .profile-info .count-data ::ng-deep mat-progress-bar {
  --mdc-linear-progress-active-indicator-color: #3e97ff !important;
}
.my-profile-container .row .profile-container .profile .profile-info .count-data ::ng-deep .mat-mdc-progress-bar {
  border-radius: 10px;
}
.my-profile-container .row .tab-container nav a {
  text-decoration: none;
  font-family: "Poppins";
}
.my-profile-container .row .tab-container nav a:hover {
  color: #3e97ff !important;
}
.my-profile-container .row .tab-container nav .tab-active {
  color: #3e97ff;
}
.my-profile-container .row .tab-container nav ::ng-deep .mat-tab-nav-bar .mat-primary .mat-ink-bar {
  background-color: #3e97ff;
}
.my-profile-container .row .tab-container ::ng-deep .mat-tab-nav-bar.mat-primary .mat-ink-bar {
  background-color: #3e97ff;
}
.my-profile-container .row .tab-container ::ng-deep .mat-tab-body-content {
  height: 100%;
  overflow: hidden;
}
.my-profile-container .row .tab-container ::ng-deep .mat-tab-label {
  font-family: "Poppins";
}
.my-profile-container .row .tab-container ::ng-deep .mat-tab-header {
  border-bottom: none;
}
.my-profile-container .row .tab-container ::ng-deep .mat-tab-list .mat-tab-labels .mat-tab-label-active {
  color: #3e97ff;
}
.my-profile-container .row .tab-container ::ng-deep .mat-tab-group.mat-primary .mat-ink-bar {
  background-color: #3e97ff;
}

@media (max-width: 769px) {
  .my-profile-container .row .profile-container .profile .profile-info .count-data {
    margin-top: 10px;
    display: inline;
  }
  .my-profile-container .row .profile-container .profile .profile-info .count-data .progress-card {
    display: block;
    padding-top: 10px;
    width: 250px;
    font-size: 12px;
  }
  .my-profile-container .row .profile-container .profile .profile-info .count-data .progress-card .progress-content .progress-info {
    display: flex;
    justify-content: space-between;
  }
  .my-profile-container .row .profile-container .profile .profile-info .count-data .progress-card .progress-content .progress-info .active {
    font-weight: 600;
    color: #181c32 !important;
  }
}
.form-actions {
  margin-top: 20px;
}

@media (max-width: 600px) {
  .my-profile-container .row {
    padding: 10px;
  }
  .my-profile-container .row .profile-container .profile {
    display: block !important;
  }
  .my-profile-container .row .profile-container .profile .profile-logo {
    float: none;
  }
  .my-profile-container .row .profile-container .profile .profile-logo .logo {
    margin: auto;
    height: 100px;
    width: 100px;
    background-color: #f3f6f9;
    font-size: 50px;
    text-align: center;
    vertical-align: middle !important;
    font-weight: 500;
    color: #7b8fa1;
    border-radius: 50%;
  }
  .my-profile-container .row .profile-container .profile .profile-logo ::ng-deep .mat-badge-small.mat-badge-overlap.mat-badge-after .mat-badge-content {
    right: -18px;
    top: 80px;
    left: 70px;
    color: transparent;
    background-color: #50cd89;
  }
  .my-profile-container .row .profile-container .profile .profile-info {
    margin-top: 20px;
    padding-left: 0px;
  }
  .my-profile-container .row .profile-container .profile .profile-info .user-data {
    text-align: center;
  }
  .my-profile-container .row .profile-container .profile .profile-info .user-data .name {
    color: #181c32;
    font-size: 16px;
    font-weight: bold;
  }
  .my-profile-container .row .profile-container .profile .profile-info .user-data .name img path {
    fill: #3e97ff;
  }
  .my-profile-container .row .profile-container .profile .profile-info .user-data .user-info {
    display: flex;
    gap: 0px;
    justify-content: space-around;
    align-items: center;
  }
  .my-profile-container .row .profile-container .profile .profile-info .user-data .user-info i {
    display: block;
  }
  .my-profile-container .row .profile-container .profile .profile-info .count-data {
    margin-top: 20px;
    display: block;
  }
  .my-profile-container .row .profile-container .profile .profile-info .count-data .count-info {
    padding-bottom: 10px;
    justify-content: center;
  }
  .my-profile-container .row .profile-container .profile .profile-info .count-data .progress-card {
    margin: auto;
  }
  .my-profile-container .row .profile-container .profile .profile-info .count-data .progress-card .progress-content .progress-info {
    display: flex;
    justify-content: space-between;
  }
  .my-profile-container .row .profile-container .profile .profile-info .count-data .progress-card .progress-content .progress-info .active {
    font-weight: 600;
    color: #181c32 !important;
  }
  .my-profile-container .row .profile-container .profile .profile-info .count-data ::ng-deep .mat-mdc-progress-bar {
    --mdc-linear-progress-active-indicator-color: #3e97ff !important;
  }
  .my-profile-container .row .profile-container .profile .profile-info .count-data ::ng-deep .mat-mdc-progress-bar {
    border-radius: 10px;
  }
}
@media (max-width: 400px) {
  .my-profile-container .row .profile-container .profile .profile-info .count-data .progress-card {
    width: 100%;
  }
}
@media screen and (max-width: 767px) {
  .notChecked {
    margin-left: 0px !important;
    margin-top: 20px !important;
  }
  .my-profile-container .row .profile-container .profile .profile-info .user-data {
    display: grid;
    justify-content: center;
  }
  .downloadUser {
    margin-top: 20px !important;
    margin-left: 0px !important;
  }
  .form-actions {
    margin-top: 20px !important;
  }
  .imageClass {
    display: flex;
    justify-content: right;
    margin-top: 20px;
  }
  .profileCss {
    margin-bottom: 100px;
  }
}
@media (width: 540px) {
  .no-gutter {
    display: grid;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .notChecked {
    margin-left: 0px !important;
  }
  .form-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/global.scss","webpack://./src/app/bas/my-profile/profile-layout-v2/profile-layout-v2.component.scss","webpack://./src/app/bas/associates/associate-layout-v2/associate-layout-v2.component.scss","webpack://./src/app/bas/users/users-layout/users-layout.component.scss"],"names":[],"mappings":"AAAA,iDAAA;AAEA;EACE,gBAAA;ACAF;;ADGA;EACE,qBAAA;ACAF;;ADGA;EACE,sBAAA;ACAF;;ADQA;EACE,sBAAA;ACLF;;ADQA;EACE,aAAA;ACLF;;ADQA;;;EAGE,oCAAA;EACA,gCAAA;ACLF;;ADQA;EACE,oCAAA;ACLF;;ADQA,cAAA;AAmDA,WAAA;AAEA,4BAAA;AAcA,gDAAA;AAuBA,2CAAA;AAaA,uBAAA;AAgBA;;EAAA;AAUA;;CAAA;AAcA,6BAAA;AAoEA,8BAAA;AASA,yBAAA;AAuBA,qBAAA;AAQA,mDAAA;AAaA,0BAAA;AAmBE;EACE,kBAAA;AC9QJ;ADsRM;EACE,yBAAA;EACA,yBAAA;EACA,2BAAA;ACpRR;ADwRI;EAtEF,yBAwE2B;EAvE3B,cAuEoC;EAtEpC,2BAsE6C;EArE7C,eAqEkE;EAnElE,gBAAA;EACA,yCAAA;AChNF;;ADuRA,mCAAA;AA8BA;EACE,wBAAA;ACjTF;;ADoTA;EACE,oCAAA;ACjTF;;ADoTA;EACE,8BAAA;ACjTF;;ADoTA;EACE,8BAAA;ACjTF;;ADoTA;EACE,oCAAA;ACjTF;;ADoTA;EACE,uBAAA;ACjTF;;ADqTE;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AClTJ;ADoTI;EAKE,yBAAA;EACA,aAAA;EACA,oBAAA;ACtTN;ADgTM;EACE,yBAAA;AC9SR;ADsTI;EACE,8BAAA;ACpTN;ADuTI;EACE,eAAA;ACrTN;ADwTI;EACE,0CAAA;EACA,4BAAA;ACtTN;ADwTM;EACE,iBAAA;EACA,sBAAA;ACtTR;ADyTM;EACE,wBAAA;ACvTR;;AD6TA;;EAEE,sBAAA;EACA,gBAAA;AC1TF;;AD6TA;EACE,mBAAA;EACA,kBAAA;AC1TF;;AD6TA;EACE,yDAAA;AC1TF;;AD6TA;EACE,aAAA;AC1TF;;AD8TE;EACE,qBAAA;AC3TJ;AD8TE;EACE,QAAA;AC5TJ;;ADiUA,kBAAA;AAEA;EACE,mBAAA;AC/TF;ADiUE;EACE,kBAAA;EACA,0BAAA;EACA,oBAAA;EACA,WAAA;AC/TJ;;ADmUA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;EACA,aAAA;AChUF;ADkUE;EACE,YAAA;AChUJ;ADmUE;EACE,0BAAA;ACjUJ;ADoUE;EACE,qBAAA;AClUJ;ADqUE;EACE,YAAA;ACnUJ;ADsUE;EACE,mBAAA;EACA,qBAAA;EACA,oBAAA;ACpUJ;ADuUE;EACE,yBAAA;EACA,aAAA;EACA,oBAAA;ACrUJ;ADuUI;EACE,yBAAA;ACrUN;ADyUI;EACE,qBAAA;ACvUN;AD0UI;EACE,uBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,cAAA;ACxUN;AD2UI;EACE,8BAAA;ACzUN;AD4UI;EACE,6BAAA;AC1UN;AD6UI;EACE,WAAA;AC3UN;AD+UE;EACE,eAAA;AC7UJ;ADiVI;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EACA,0CAAA;EACA,4BAAA;EACA,2BAAA;AC/UN;ADkVI;EACE,wBAAA;AChVN;;ADqVA,kBAAA;AAGA;;EAEE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,qBAAA;ACpVF;;ADuVA;EACE,iCAAA;ACpVF;ADsVE;EACE,uCAAA;ACpVJ;;ADwVA;EACE,yCAAA;ACrVF;ADuVE;EACE,+CAAA;ACrVJ;;ADlQA,iDAAA;AAEA;EACE,gBAAA;ACoQF;;ADjQA;EACE,qBAAA;ACoQF;;ADjQA;EACE,sBAAA;ACoQF;;AD5PA;EACE,sBAAA;AC+PF;;AD5PA;EACE,aAAA;AC+PF;;AD5PA;;;EAGE,oCAAA;EACA,gCAAA;AC+PF;;AD5PA;EACE,oCAAA;AC+PF;;AD5PA,cAAA;AAmDA,WAAA;AAEA,4BAAA;AAcA,gDAAA;AAuBA,2CAAA;AAaA,uBAAA;AAgBA;;EAAA;AAUA;;CAAA;AAcA,6BAAA;AAoEA,8BAAA;AASA,yBAAA;AAuBA,qBAAA;AAQA,mDAAA;AAaA,0BAAA;AAmBE;EACE,kBAAA;ACVJ;ADkBM;EACE,yBAAA;EACA,yBAAA;EACA,2BAAA;AChBR;ADoBI;EAtEF,yBAwE2B;EAvE3B,cAuEoC;EAtEpC,2BAsE6C;EArE7C,eAqEkE;EAnElE,gBAAA;EACA,yCAAA;ACoDF;;ADmBA,mCAAA;AA8BA;EACE,wBAAA;AC7CF;;ADgDA;EACE,oCAAA;AC7CF;;ADgDA;EACE,8BAAA;AC7CF;;ADgDA;EACE,8BAAA;AC7CF;;ADgDA;EACE,oCAAA;AC7CF;;ADgDA;EACE,uBAAA;AC7CF;;ADiDE;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AC9CJ;ADgDI;EAKE,yBAAA;EACA,aAAA;EACA,oBAAA;AClDN;AD4CM;EACE,yBAAA;AC1CR;ADkDI;EACE,8BAAA;AChDN;ADmDI;EACE,eAAA;ACjDN;ADoDI;EACE,0CAAA;EACA,4BAAA;AClDN;ADoDM;EACE,iBAAA;EACA,sBAAA;AClDR;ADqDM;EACE,wBAAA;ACnDR;;ADyDA;;EAEE,sBAAA;EACA,gBAAA;ACtDF;;ADyDA;EACE,mBAAA;EACA,kBAAA;ACtDF;;ADyDA;EACE,yDAAA;ACtDF;;ADyDA;EACE,aAAA;ACtDF;;AD0DE;EACE,qBAAA;ACvDJ;AD0DE;EACE,QAAA;ACxDJ;;AD6DA,kBAAA;AAEA;EACE,mBAAA;AC3DF;AD6DE;EACE,kBAAA;EACA,0BAAA;EACA,oBAAA;EACA,WAAA;AC3DJ;;AD+DA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;EACA,aAAA;AC5DF;AD8DE;EACE,YAAA;AC5DJ;AD+DE;EACE,0BAAA;AC7DJ;ADgEE;EACE,qBAAA;AC9DJ;ADiEE;EACE,YAAA;AC/DJ;ADkEE;EACE,mBAAA;EACA,qBAAA;EACA,oBAAA;AChEJ;ADmEE;EACE,yBAAA;EACA,aAAA;EACA,oBAAA;ACjEJ;ADmEI;EACE,yBAAA;ACjEN;ADqEI;EACE,qBAAA;ACnEN;ADsEI;EACE,uBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,cAAA;ACpEN;ADuEI;EACE,8BAAA;ACrEN;ADwEI;EACE,6BAAA;ACtEN;ADyEI;EACE,WAAA;ACvEN;AD2EE;EACE,eAAA;ACzEJ;AD6EI;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EACA,0CAAA;EACA,4BAAA;EACA,2BAAA;AC3EN;AD8EI;EACE,wBAAA;AC5EN;;ADiFA,kBAAA;AAGA;;EAEE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,qBAAA;AChFF;;ADmFA;EACE,iCAAA;AChFF;ADkFE;EACE,uCAAA;AChFJ;;ADoFA;EACE,yCAAA;ACjFF;ADmFE;EACE,+CAAA;ACjFJ;;ADtgBA,iDAAA;AAEA;EACE,gBAAA;ACwgBF;;ADrgBA;EACE,qBAAA;ACwgBF;;ADrgBA;EACE,sBAAA;ACwgBF;;ADhgBA;EACE,sBAAA;ACmgBF;;ADhgBA;EACE,aAAA;ACmgBF;;ADhgBA;;;EAGE,oCAAA;EACA,gCAAA;ACmgBF;;ADhgBA;EACE,oCAAA;ACmgBF;;ADhgBA,cAAA;AAmDA,WAAA;AAEA,4BAAA;AAcA,gDAAA;AAuBA,2CAAA;AAaA,uBAAA;AAgBA;;EAAA;AAUA;;CAAA;AAcA,6BAAA;AAoEA,8BAAA;AASA,yBAAA;AAuBA,qBAAA;AAQA,mDAAA;AAaA,0BAAA;AAmBE;EACE,kBAAA;AC0PJ;ADlPM;EACE,yBAAA;EACA,yBAAA;EACA,2BAAA;ACoPR;ADhPI;EAtEF,yBAwE2B;EAvE3B,cAuEoC;EAtEpC,2BAsE6C;EArE7C,eAqEkE;EAnElE,gBAAA;EACA,yCAAA;ACwTF;;ADjPA,mCAAA;AA8BA;EACE,wBAAA;ACuNF;;ADpNA;EACE,oCAAA;ACuNF;;ADpNA;EACE,8BAAA;ACuNF;;ADpNA;EACE,8BAAA;ACuNF;;ADpNA;EACE,oCAAA;ACuNF;;ADpNA;EACE,uBAAA;ACuNF;;ADnNE;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;ACsNJ;ADpNI;EAKE,yBAAA;EACA,aAAA;EACA,oBAAA;ACkNN;ADxNM;EACE,yBAAA;AC0NR;ADlNI;EACE,8BAAA;ACoNN;ADjNI;EACE,eAAA;ACmNN;ADhNI;EACE,0CAAA;EACA,4BAAA;ACkNN;ADhNM;EACE,iBAAA;EACA,sBAAA;ACkNR;AD/MM;EACE,wBAAA;ACiNR;;AD3MA;;EAEE,sBAAA;EACA,gBAAA;AC8MF;;AD3MA;EACE,mBAAA;EACA,kBAAA;AC8MF;;AD3MA;EACE,yDAAA;AC8MF;;AD3MA;EACE,aAAA;AC8MF;;AD1ME;EACE,qBAAA;AC6MJ;AD1ME;EACE,QAAA;AC4MJ;;ADvMA,kBAAA;AAEA;EACE,mBAAA;ACyMF;ADvME;EACE,kBAAA;EACA,0BAAA;EACA,oBAAA;EACA,WAAA;ACyMJ;;ADrMA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;EACA,aAAA;ACwMF;ADtME;EACE,YAAA;ACwMJ;ADrME;EACE,0BAAA;ACuMJ;ADpME;EACE,qBAAA;ACsMJ;ADnME;EACE,YAAA;ACqMJ;ADlME;EACE,mBAAA;EACA,qBAAA;EACA,oBAAA;ACoMJ;ADjME;EACE,yBAAA;EACA,aAAA;EACA,oBAAA;ACmMJ;ADjMI;EACE,yBAAA;ACmMN;AD/LI;EACE,qBAAA;ACiMN;AD9LI;EACE,uBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,cAAA;ACgMN;AD7LI;EACE,8BAAA;AC+LN;AD5LI;EACE,6BAAA;AC8LN;AD3LI;EACE,WAAA;AC6LN;ADzLE;EACE,eAAA;AC2LJ;ADvLI;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EACA,0CAAA;EACA,4BAAA;EACA,2BAAA;ACyLN;ADtLI;EACE,wBAAA;ACwLN;;ADnLA,kBAAA;AAGA;;EAEE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,qBAAA;ACoLF;;ADjLA;EACE,iCAAA;ACoLF;ADlLE;EACE,uCAAA;ACoLJ;;ADhLA;EACE,yCAAA;ACmLF;ADjLE;EACE,+CAAA;ACmLJ;;ACxwBA;EACE,gBAAA;AD2wBF;ACzwBE;EACE,uBAAA;AD2wBJ;;ACvwBA;EACE,YAAA;AD0wBF;ACxwBE;EACE,aAAA;EACA,sBAAA;AD0wBJ;ACvwBE;EACE,YAAA;ADywBJ;;ACrwBA;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;ADwwBF;;ACrwBA;EACE,uBAAA;ADwwBF;;ACrwBA;EACE,wBAAA;ADwwBF;;ACrwBA;EACE,wBAAA;ADwwBF;;ACrwBA;;EAEE,cFHQ;AC2wBV;;ACrwBA;;EAEE,cFRQ;ACgxBV;;ACrwBA;EACE,cFUS;EETT,kCF6Ba;EE5Bb,gBF+BO;ACyuBT;;ACrwBA;EACE,wBAAA;ADwwBF;;ACrwBA;EACE,kCFoBa;EEnBb,gBFwBY;EAyGZ,qBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,0BAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EACA,6BAAA;EAzGA,kBE9BE;EFyIF,eE3IE;EF4IF,gBE3IE;EF4IF,YE9IE;EF+IF,gBEhJE;EFiJF,mBA7KQ;EA8KR,cAzIM;EA0IN,kBAAA;EACA,kBAAA;EE9IA,0BAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;ADwxBF;AD5oBE;EACE,mBAAA;AC8oBJ;AD3oBE;EACE,aAAA;AC6oBJ;AD1oBE;EAME,yBAAA;EACA,uCAAA;EACA,qBAAA;ACuoBJ;ADjoBE;EAGE,mBA3MM;EA4MN,cAvKI;EAwKJ,yBAAA;ACioBJ;ACtyBE;EACE,cFJI;EEKJ,kBAAA;EACA,cAAA;EACA,iBAAA;ADwyBJ;ACryBE;EAEE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;ADsyBJ;;AClyBA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,uDAAA;EACA,qBAAA;ADqyBF;;AClyBA;EACE,OAAA;ADqyBF;;ACjyBA;EACE,uBAAA;ADoyBF;;AChyBE;EACE,eAAA;ADmyBJ;;AC9xBA;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;ADiyBF;;AC9xBA;EACE,2BAAA;ADiyBF;;AC9xBA;EACE,WAAA;EACA,iBAAA;ADiyBF;;AC9xBA;EACE,4BAAA;ADiyBF;;AC9xBA;EACE,yBFpEM;EEqEN,kBAAA;EACA,sBAAA;EACA,kBAAA;ADiyBF;;AC9xBA;EACE,YAAA;EACA,gBAAA;EACA,mBF7EM;EE8EN,SAAA;ADiyBF;;AC9xBA;EACE,cFjFM;EEkFN,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;ADiyBF;;AC9xBA;EACE,iCAAA;ADiyBF;;AC9xBA;EACE,aAAA;EACA,yBAAA;EACA,eAAA;ADiyBF;;AC9xBA;EACE,aAAA;EACA,QAAA;ADiyBF;;AC9xBA;EACE,0BAAA;EACA,eAAA;EAIA,yBFjJc;EEkJd,kBAAA;EACA,YAAA;EACA,kBAAA;AD8xBF;;AC3xBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBF3Jc;EE4Jd,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;AD8xBF;AC5xBE;EACE,eAAA;EACA,cFhJO;EEiJP,kBAAA;AD8xBJ;AC1xBE;EACE,WAAA;EACA,YAAA;EACA,4CAAA;EACA,4BAAA;EACA,2BAAA;AD4xBJ;;ACtxBA;EACE,yBFlJM;EEmJN,YAAA;EACA,gBAAA;EACA,4BAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;ADyxBF;;ACtxBA;EACE,aAAA;EACA,gBAAA;ADyxBF;;ACtxBA;EACE,0BAAA;EACA,mBAAA;EACA,yBAAA;EACA,kCF/Ja;ACw7Bf;;ACrxBE;EACE,cF9MM;ACs+BV;;ACpxBA;EAKE,gCAAA;ADmxBF;ACvxBE;EACE,cFpNM;AC6+BV;;ACnxBA;EAKE,cF/NQ;EEgOR,gCAAA;ADkxBF;ACvxBE;EACE,cF5NM;ACq/BV;;AClxBA;EAeE,yBF7MM;ACo9BR;ACrxBE;EACE,YAAA;ADuxBJ;ACnxBI;EACE,gBAAA;ADqxBN;AClxBI;EACE,gBAAA;ADoxBN;;AC5wBA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AD+wBF;AC7wBE;EACE,YAAA;AD+wBJ;;AC3wBA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AD8wBF;;AC3wBA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AD8wBF;AC5wBE;EACE,UAAA;AD8wBJ;AC1wBM;;EAEE,eAAA;EACA,cF/PG;EEgQH,sBAAA;AD4wBR;ACzwBM;EACE,qBFvQG;EEwQH,2BAAA;AD2wBR;ACtwBE;EACE,aAAA;EACA,qBAAA;EACA,iBAAA;ADwwBJ;;ACpwBA;EACE,qBAAA;ADuwBF;;ACpwBA;EACE,0BAAA;EACA,4BAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;EACA,qDAAA;EACA,qBAAA;EACA,yBFjTc;EEkTd,YAAA;EACA,cF/RS;EEgST,2BAAA;EACA,kBAAA;ADuwBF;;ACpwBA;EACE,0BAAA;EACA,2BAAA;EACA,YAAA;EACA,kBAAA;EAGA,4BAAA;EAEA,qDAAA;EACA,qBAAA;EACA,yBFnUc;EEoUd,YAAA;EACA,cFjTS;EEkTT,2BAAA;EACA,kBAAA;ADowBF;;ACjwBA;EACE,0BAAA;EACA,kBAAA;EACA,kCFrSa;EEsSb,gBFnSO;ACuiCT;AClwBE;EACE,yBAAA;ADowBJ;ACjwBE;EACE,cFvVM;AC0lCV;AChwBE;EACE,iBAAA;ADkwBJ;AC/vBE;EACE,WAAA;ADiwBJ;;AC7vBA;EACE,0BAAA;EACA,6BAAA;EACA,kBAAA;EACA,qCAAA;EACA;uBAAA;EAEA,gCAAA;EACA,qBAAA;EACA,yBF1Wc;EE2Wd,YAAA;EACA,cFxVS;EEyVT,2BAAA;ADgwBF;;AC7vBA;EACE,wBAAA;ADgwBF;;AC7vBA;EACE,YAAA;ADgwBF;AC9vBE;EACE,WAAA;ADgwBJ;;AC5vBA;EACE,UAAA;EACA,YAAA;AD+vBF;;AC5vBA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBFrYc;EEsYd,YAAA;EACA,eAAA;EACA,cFpXS;EEqXT,kBAAA;AD+vBF;AC7vBE;EACE,aAAA;AD+vBJ;;AC3vBA;EACE,cF7XS;EE8XT,kBAAA;AD8vBF;;AC3vBA;EACE,kCF9Wa;EE+Wb,gBF5WO;EE6WP,6BAAA;EACA,gBAAA;AD8vBF;AC5vBE;EACE,yBAAA;AD8vBJ;;AC1vBA;EACE,6BAAA;EACA,yBAAA;EACA,oCAAA;AD6vBF;;AC1vBA;EACE,oCAAA;AD6vBF;;AC1vBA;EACE,kCFnYa;EEoYb,gBFjYO;EEkYP,oCAAA;EACA,yBAAA;EACA,eAAA;AD6vBF;;AC1vBA;EACE,YAAA;AD6vBF;;AC1vBA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,cFvaS;EEwaT,kCFpZa;EEqZb,gBFlZO;EEmZP,eAAA;EACA,0CAAA;EACA,4BAAA;EACA,0BAAA;EACA,yBFlcc;EEmcd,eAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AD6vBF;;AC1vBA;EACE,aAAA;AD6vBF;;AC1vBA;EACE,UAAA;AD6vBF;;AC1vBA;EAEE,eAAA;EACA,cFvcK;EEwcL,aAAA;AD4vBF;;ACzvBA;EACE,oCAAA;EACA,kBAAA;AD4vBF;;ACzvBA;;EAEE,oCAAA;AD4vBF;;ACzvBA;;EAEE,yBAAA;AD4vBF;;ACzvBA;EACE,cF3dK;ACutCP;;ACxvBE;EACE,oCAAA;AD2vBJ;ACxvBE;EACE,oCAAA;EACA,kBAAA;AD0vBJ;;ACrvBE;EACE,aAAA;EACA,cAAA;EACA,qBAAA;ADwvBJ;ACpvBQ;EACE,kBAAA;ADsvBV;ACpvBU;EACE,yBFtgBF;AC4vCV;AClvBY;EACE,cFteN;AC0tCR;;AC3uBA;EACE,yBAAA;EACA,kCF5ea;EE6eb,gBF1eO;ACwtCT;;AC3uBA;EACE,sBAAA;AD8uBF;;AC3uBA;EACE,yBAAA;AD8uBF;;AC3uBA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;AD8uBF;;AC3uBA;EACE;IACE,sBAAA;ED8uBF;AACF;AC3uBA;EACE;IACE,gBAAA;ED6uBF;EC1uBA;IACE,sBAAA;ED4uBF;ECzuBA;IACE,qBAAA;IACA,qBAAA;ED2uBF;AACF;ACxuBA;EACE;IACE,sBAAA;ED0uBF;ECvuBA;IACE,kCAAA;EDyuBF;AACF;ACtuBA;EACE;IACE,gBAAA;EDwuBF;ECtuBA;IACE,eAAA;EDwuBF;AACF;ACruBA;EACE;IACE,gBAAA;EDuuBF;ECpuBA;IACE,cAAA;EDsuBF;ECnuBA;IACE,iBAAA;EDquBF;ECluBA;IACE,yBAAA;IACA,iBAAA;EDouBF;AACF;ACjuBA;EACE;IACE,gBAAA;EDmuBF;AACF;AChuBA;EACE;IACE,mCAAA;EDkuBF;AACF;AC/tBA;EACE;IACE,oBAAA;EDiuBF;AACF;AC9tBA;EACE;IACE,yBAAA;EDguBF;EC7tBA;IACE,sBAAA;ED+tBF;AACF;AEh4CA;EACE,yBHyEM;EGxEN,YAAA;EACA,4BAAA;EACA,6BAAA;EACA,aAAA;AFk4CF;;AE/3CA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AFk4CF;AEh4CE;EACE,YAAA;AFk4CJ;;AE93CA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AFi4CF;;AE93CA;EACE,WAAA;AFi4CF;;AE53CE;;EACE,yBAAA;EACA,yBHMY;AC03ChB;;AE53CA;EACE,0BAAA;EACA,mBAAA;EACA,yBAAA;EACA,kCHsCa;ACy1Cf;;AE33CE;EACE,cHTM;ACu4CV;;AE13CA;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;AF63CF;;AE13CA;EACE,aAAA;EACA,8BAAA;EACA,yBHcM;EGbN,kBAAA;EACA,sBAAA;EACA,kBAAA;AF63CF;AE33CE;EACE,gBAAA;EACA,iBAAA;AF63CJ;;AEz3CA;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;AF43CF;AE13CE;EACE,YAAA;EACA,UAAA;EACA,qBAAA;AF43CJ;AE13CI;EACE,cH7CI;ACy6CV;AEx3CE;EAKE,gCAAA;AFs3CJ;AE13CI;EACE,cHnDI;AC+6CV;AEt3CE;EACE,2BAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,gBHhBM;EGiBN,YAAA;AFw3CJ;;AEp3CA;EACE,2BAAA;EACA,cAAA;AFu3CF;AEr3CE;EACE,YAAA;EACA,eAAA;EACA,mBHrCI;AC45CR;AEp3CE;EAVF;IAWI,2BAAA;EFu3CF;AACF;;AEp3CA;EACE,SAAA;AFu3CF;;AEp3CA;EACE,sBAAA;EACA,iBAAA;EACA,eAAA;AFu3CF;;AEp3CA;EACE,kCHnDa;EGoDb,gBH/CY;EAyGZ,qBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,0BAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EACA,6BAAA;EAzGA,kBGyCE;EHkEF,eGpEE;EHqEF,gBGpEE;EHqEF,YGvEE;EHwEF,gBGzEE;EH0EF,mBA7KQ;EA8KR,cAzIM;EA0IN,kBAAA;EACA,kBAAA;EGvEA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,sBAAA;AFu4CF;ADl0CE;EACE,mBAAA;ACo0CJ;ADj0CE;EACE,aAAA;ACm0CJ;ADh0CE;EAME,yBAAA;EACA,uCAAA;EACA,qBAAA;AC6zCJ;ADvzCE;EAGE,mBA3MM;EA4MN,cAvKI;EAwKJ,yBAAA;ACuzCJ;AEr5CE;EACE,cH3EI;EG4EJ,kBAAA;EACA,UAAA;EACA,iBAAA;AFu5CJ;AEp5CE;EACE,2BAAA;EACA,WAAA;EACA,6BAAA;EACA,UAAA;EACA,kBAAA;AFs5CJ;;AEl5CA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,uDAAA;EACA,qBAAA;AFq5CF;;AEl5CA;EACE,OAAA;AFq5CF;;AEl5CA;EACE,WAAA;EACA,mBH1IO;AC+hDT;AEn5CE;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,SAAA;AFq5CJ;ADn2CE;EAGE,mBArMK;EAsML,cAvKI;EAwKJ,yBAAA;ACm2CJ;;AEp5CA;EACE,WAAA;EACA,kBAAA;EACA,cHzJO;EG0JP,yBHxJa;EGyJb,iBAAA;EACA,kBAAA;EACA,kCHzHa;EG0Hb,gBAAA;EACA,eAAA;AFu5CF;;AEp5CA;EACE,SAAA;EACA,mBAAA;AFu5CF;;AEp5CA;EACE,sBAAA;AFu5CF;;AEp5CA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AFu5CF;;AEp5CA;EACE,yBAAA;AFu5CF;;AEp5CA;EACE,iBAAA;AFu5CF;;AEp5CA;EACE;IACE,2BAAA;EFu5CF;AACF;AEp5CA;EACE;IACE,sBAAA;EFs5CF;AACF;AEn5CA;EACE;IACE,sBAAA;EFq5CF;EEl5CA;;IAEE,WAAA;EFo5CF;AACF;AA5oDA;EACE,kBAAA;AA8oDF;;AA3oDA;EACE,UAAA;AA8oDF;;AA3oDA;EACE,oCAAA;AA8oDF;AA5oDE;EACE,yBAAA;AA8oDJ;;AA1oDA;ED6KE,qBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,0BAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EACA,6BAAA;EAzGA,kBC1EE;EDqLF,eCvLE;EDwLF,gBCvLE;EDwLF,YC1LE;ED2LF,gBC5LE;ED6LF,mBAzJS;EA0JT,cAxJS;EAyJT,kBAAA;EACA,kBAAA;EC1LA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;AA6pDF;ADr+CE;EACE,mBAAA;ACu+CJ;ADp+CE;EACE,aAAA;ACs+CJ;ADn+CE;EAME,yBAAA;EACA,uCAAA;EACA,qBAAA;ACg+CJ;AD19CE;EAGE,mBAvLO;EAwLP,cAtLO;EAuLP,yBAAA;AC09CJ;AA3qDE;EACE,cDwCI;ECvCJ,kBAAA;EACA,UAAA;EACA,iBAAA;AA6qDJ;;AAzqDA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,uDAAA;EACA,qBAAA;AA4qDF;;AAzqDA;EACE,OAAA;AA4qDF;;AAzqDA;EACE,yBAAA;AA4qDF;;AAzqDA;EACE,yBAAA;AA4qDF;;AAzqDA;EACE,gCAAA;AA4qDF;;AAzqDA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AA4qDF;AA1qDE;EACE,YAAA;AA4qDJ;;AAxqDA;EACE,6BAAA;AA2qDF;;AAxqDA;EACE,6BAAA;AA2qDF;;AAxqDA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA2qDF;;AAxqDA;EACE,YAAA;EACA,sBAAA;EACA,YAAA;AA2qDF;AAzqDE;EACE,yBAAA;EACA,aAAA;AA2qDJ;AAzqDI;EACE,gCAAA;EACA,oBAAA;AA2qDN;AAxqDQ;EACE,WAAA;AA0qDV;AAxqDU;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;AA0qDZ;AAvqDU;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,yBDxFF;ACiwDV;AArqDQ;EACE,kCDtDK;ECuDL,kBAAA;EACA,cD9DK;EC+DL,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,oBAAA;AAuqDV;AArqDU;EACE,aAAA;EACA,8BAAA;AAuqDZ;AArqDY;EACE,cDpFH;ECqFG,eAAA;EACA,gBDhEA;ACuuDd;AAnqDgB;;EAEE,iGAAA;AAqqDlB;AAlqDgB;EACE,+FAAA;AAoqDlB;AAjqDgB;EACE,6FAAA;AAmqDlB;AAhqDgB;EACE,6FAAA;AAkqDlB;AA9pDkB;EACE,aDtIV;ACsyDV;AA1pDY;EACE,aAAA;EACA,SAAA;AA4pDd;AA1pDc;EACE,eAAA;AA4pDhB;AAzpDc;EACE,eAAA;AA2pDhB;AAxpDc;EACE,iBAAA;AA0pDhB;AAvpDc;EACE,iBAAA;AAypDhB;AAtpDc;EACE,iBAAA;AAwpDhB;AArpDc;EACE,eAAA;AAupDhB;AAlpDU;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;AAopDZ;AAlpDY;EACE,aAAA;AAopDd;AAlpDc;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;AAopDhB;AAlpDgB;EACE,eAAA;EACA,gBAAA;EACA,cD5KX;ACg0DP;AAjpDgB;EACE,eAAA;EACA,cD9JH;ACizDf;AA/oDc;EACE,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;AAipDhB;AA/oDgB;EACE,eAAA;EACA,gBAAA;EACA,cDhMX;ACi1DP;AA9oDgB;EACE,eAAA;EACA,cDlLH;ACk0Df;AA3oDY;EACE,YAAA;EACA,eAAA;EACA,gBAAA;AA6oDd;AA1oDgB;EACE,aAAA;EACA,8BAAA;AA4oDlB;AA1oDkB;EACE,gBAAA;EACA,yBAAA;AA4oDpB;AAtoDY;EACE,gEAAA;AAwoDd;AAroDY;EACE,mBAAA;AAuoDd;AA9nDQ;EACE,qBAAA;EACA,sBAAA;AAgoDV;AA9nDU;EACE,yBAAA;AAgoDZ;AA5nDQ;EACE,cDrQA;ACm4DV;AA3nDQ;EACE,yBDzQA;ACs4DV;AAznDM;EACE,yBD9QE;ACy4DV;AAxnDM;EACE,YAAA;EACA,gBAAA;AA0nDR;AAvnDM;EACE,sBAAA;AAynDR;AAtnDM;EACE,mBAAA;AAwnDR;AArnDM;EACE,cD/RE;ACs5DV;AApnDM;EACE,yBDnSE;ACy5DV;;AA9mDA;EAMY;IACE,gBAAA;IACA,eAAA;EA4mDZ;EA1mDY;IACE,cAAA;IACA,iBAAA;IACA,YAAA;IACA,eAAA;EA4mDd;EAzmDgB;IACE,aAAA;IACA,8BAAA;EA2mDlB;EAzmDkB;IACE,gBAAA;IACA,yBAAA;EA2mDpB;AACF;AA/lDA;EACE,gBAAA;AAimDF;;AA9lDA;EAEI;IACE,aAAA;EAgmDJ;EA7lDM;IACE,yBAAA;EA+lDR;EA7lDQ;IACE,WAAA;EA+lDV;EA7lDU;IACE,YAAA;IACA,aAAA;IACA,YAAA;IACA,yBAAA;IACA,eAAA;IACA,kBAAA;IACA,iCAAA;IACA,gBAAA;IACA,cAAA;IACA,kBAAA;EA+lDZ;EA5lDU;IACE,YAAA;IACA,SAAA;IACA,UAAA;IACA,kBAAA;IACA,yBD9WJ;EC48DR;EA1lDQ;IACE,gBAAA;IACA,iBAAA;EA4lDV;EA1lDU;IACE,kBAAA;EA4lDZ;EA1lDY;IACE,cD5WT;IC6WS,eAAA;IACA,iBAAA;EA4lDd;EAzlDgB;IACE,aDnYV;EC89DR;EAtlDY;IACE,aAAA;IACA,QAAA;IACA,6BAAA;IACA,mBAAA;EAwlDd;EAtlDc;IACE,cAAA;EAwlDhB;EAnlDU;IACE,gBAAA;IACA,cAAA;EAqlDZ;EAnlDY;IACE,oBAAA;IACA,uBAAA;EAqlDd;EAllDY;IACE,YAAA;EAolDd;EAjlDgB;IACE,aAAA;IACA,8BAAA;EAmlDlB;EAjlDkB;IACE,gBAAA;IACA,yBAAA;EAmlDpB;EA7kDY;IACE,gEAAA;EA+kDd;EA5kDY;IACE,mBAAA;EA8kDd;AACF;AArkDA;EAOc;IACE,WAAA;EAikDd;AACF;AAxjDA;EACE;IACE,2BAAA;IACA,2BAAA;EA0jDF;EAvjDA;IACE,aAAA;IACA,uBAAA;EAyjDF;EAtjDA;IACE,2BAAA;IACA,2BAAA;EAwjDF;EArjDA;IACE,2BAAA;EAujDF;EApjDA;IACE,aAAA;IACA,sBAAA;IACA,gBAAA;EAsjDF;EAnjDA;IACE,oBAAA;EAqjDF;AACF;AAljDA;EACE;IACE,aAAA;EAojDF;AACF;AAjjDA;EACE;IACE,2BAAA;EAmjDF;EAhjDA;IACE,aAAA;IACA,yBAAA;IACA,gBAAA;EAkjDF;AACF","sourcesContent":["/* Global variables adn mixins are defined here */\n\n::ng-deep .cdk-global-scrollblock {\n  overflow: hidden;\n}\n\n::ng-deep mat-pseudo-checkbox {\n  width: 0px !important;\n}\n\n::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n  width: auto !important;\n  // height: auto !important;\n}\n\n// ::ng-deep mat-option{\n//     display: flex !important;\n//     justify-content: center !important;\n// }\n::ng-deep .mdc-list-item__primary-text {\n  margin: 0px !important;\n}\n\n::ng-deep .mdc-tab__ripple {\n  display: none;\n}\n\n::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,\n.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,\n.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=\"true\"]:enabled~.mdc-checkbox__background {\n  background-color: #3e97ff !important;\n  border-color: #3e97ff !important;\n}\n\n.toaster {\n  background-color: #f4f7ff !important;\n}\n\n/* variables */\n\n$primary: #3e97ff;\n$primary-active: #2884ef;\n$primary-light: #f2f4ff;\n$success: #50cd89;\n$success-active: #50cd89;\n$success-light: #e8fff3;\n$danger: #ff4b55;\n$danger-active: #d9214e;\n$danger-light: #fff5f8;\n$info: #7dcfdb;\n$info-active: #4fc9da;\n$info-light: #edf9fb;\n$warning: #ffa800;\n$warning-active: #ffa800;\n$warning-light: #fff7e7;\n$white: #ffffff;\n$white-active: #f5f8fa;\n$dark: #181c32;\n$gray-100: #f9f9f9;\n$gray-200: #f1f1f2;\n$gray-300: #e1e3ea;\n$gray-400: #d8d8e5;\n$gray-500: #959cbd;\n$gray-600: #7e8299;\n$gray-700: #5e6278;\n$gray-800: #3f4254;\n$gray-900: #181c32;\n$gray-button: #1e2238;\n\n//\n$primary-clr-dark: #232f3e;\n$primary-clr: #3e97ff;\n$primary-clr-alpha: #00a8e1;\n$bg-clr: #f3f3f3;\n$bg-clr-alpha: #edeced;\n$primary-ft-clr: #595a5c;\n$primary-grey: #707070;\n$white: #ffffff;\n$black: #3f4254;\n// $success: #347439;\n$failure: #ff0000;\n$grey: #cccccc;\n$primary-font: \"Poppins\", sans-serif;\n$ft-thin: 300;\n$ft-regular: 400;\n$ft-500: 500;\n$ft-bold: 700;\n$ft-semibold: 600;\n\n/* MIXINS */\n\n/* mixin for border radius */\n\n@mixin border-radius($top, $right, $bottom, $left) {\n  -webkit-border-radius: $top $right $bottom $left;\n  -moz-border-radius: $top $right $bottom $left;\n  border-radius: $top $right $bottom $left;\n}\n\n@mixin border-single-radius($rad) {\n  -webkit-border-radius: $rad;\n  -moz-border-radius: $rad;\n  border-radius: $rad;\n}\n\n/* To create a section at the center of window */\n@mixin create-centered-section($width,\n  $border-radius,\n  $padding-tb,\n  $padding-lr,\n  $border,\n  $background,\n  $left) {\n  position: absolute;\n  margin: auto;\n  top: 0;\n  left: $left;\n  right: 0;\n  bottom: 0;\n  width: $width;\n  height: 50vh;\n  // max-height: 520px;\n  border-radius: $border-radius;\n  padding: $padding-tb $padding-lr;\n  border: $border;\n  background: $background;\n}\n\n/* To include and adjust background image */\n@mixin set-background-image($bg-color,\n  $bg-url,\n  $bg-position,\n  $bg-repeat,\n  $bg-size) {\n  background: $bg-color;\n  background-image: $bg-url;\n  background-position: $bg-position;\n  background-repeat: $bg-repeat;\n  background-size: $bg-size;\n}\n\n/* to split the input */\n@mixin split-input($ltr-space,\n  $bg-img,\n  $bg-position,\n  $bg-size,\n  $bg-repeat,\n  $bg-pos-x) {\n  border: 0;\n  letter-spacing: $ltr-space;\n  background-image: $bg-img;\n  background-position: bottom;\n  background-size: $bg-size;\n  background-repeat: $bg-repeat;\n  background-position-x: $bg-pos-x;\n}\n\n/* box-shadow generator\n    $clr- in RGBA format\n */\n\n@mixin box-shadows($hset, $vset, $blur, $spread, $clr) {\n  -webkit-box-shadow: $hset $vset $blur $spread $clr;\n  -moz-box-shadow: $hset $vset $blur $spread $clr;\n  box-shadow: $hset $vset $blur $spread $clr;\n}\n\n/*\nremove the autofilled background color\n*/\n@mixin remove-autofill-background() {\n\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  input:-webkit-autofill:active {\n    transition-delay: 99999s;\n    -webkit-transition-delay: 99999s;\n  }\n}\n\n/* mixin for create buttons */\n\n@mixin create-buttons($bgClr,\n  $clr,\n  $ptb,\n  $plr,\n  $width,\n  $height,\n  $ft-size,\n  $ft-weight,\n  $rad) {\n  display: inline-block;\n  // padding: $ptb $plr;\n  margin-bottom: 0;\n  line-height: calc($height/2);\n  text-align: left;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  @include border-single-radius($rad);\n  font-size: $ft-size;\n  font-weight: $ft-weight;\n  height: $height;\n  min-width: $width;\n  background: $bgClr;\n  color: $clr;\n  position: relative;\n  text-align: center;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &:hover,\n  &:focus,\n  &:active {\n    // background: $clr;\n    // color: $bgClr;\n    // border: 1px solid $bgClr;\n    transition-duration: 0.5s;\n    transition-timing-function: ease-in-out;\n    text-decoration: none;\n  }\n}\n\n@mixin no-transition($bg-color, $color) {\n\n  &:hover,\n  &:focus,\n  &:active {\n    background: $bg-color;\n    color: $color;\n    border: 1px solid $bg-color;\n  }\n}\n\n/* generate margin & padding */\n@mixin generate-margin($tp, $rt, $bt, $lt) {\n  margin: $tp $rt $bt $lt;\n}\n\n@mixin generate-padding($tp, $rt, $bt, $lt) {\n  padding: $tp $rt $bt $lt;\n}\n\n/* to set the table row */\n@mixin set-table-row($bg-color,\n  $color,\n  $border,\n  $font-size,\n  $font-weight,\n  $fontFamily: \"\"\n\n) {\n  background-color: $bg-color;\n  color: $color;\n  border: $border;\n  font-size: $font-size;\n  // font-weight: $font-weight;\n  font-weight: 500;\n  font-family: \"Amazon Ember Display Light\";\n\n  @if $fontFamily !=\"\" {\n    font-family: $fontFamily;\n    font-weight: $font-weight;\n  }\n}\n\n/* to set the image */\n@mixin set-image-config($width, $height, $cursor, $margin-right) {\n  width: $width;\n  height: $height;\n  cursor: $cursor;\n  margin-right: $margin-right;\n}\n\n/* to set the styles for first and last child div */\n@mixin set-child-div($color1, $font-size1, $font-weight1, $color2) {\n  div:first-child {\n    color: $color1;\n    font-size: $font-size1;\n    font-weight: $font-weight1;\n  }\n\n  div:last-child {\n    color: $color2;\n  }\n}\n\n/* to set the font style */\n@mixin set-font-config($fontSize,\n  $fontWeight,\n  $fontColor,\n  $textAlign,\n  $fontFamily: \"\"\n\n) {\n  font-size: $fontSize;\n  font-weight: $fontWeight;\n  color: $fontColor;\n  text-align: $textAlign;\n\n  @if $fontFamily !=\"\" {\n    font-family: $fontFamily;\n  }\n}\n\n.ast-table {\n  .table {\n    margin-bottom: 0px;\n  }\n\n  table {\n    thead {\n\n      // @mixin set-table-row($bg-color, $color, $border, $font-size, $font-weight)\n      // @include set-table-row($white, #231f20, 0.5px solid #e2e2e1, 16px, 300) ;\n      th {\n        background-color: #edeced;\n        border: 1px solid #dee2e6;\n        border-top: none !important;\n      }\n    }\n\n    td {\n      // @mixin set-table-row($bg-color, $color, $border, $font-size, $font-weight)\n      @include set-table-row(#fafafa, #231f20, 0.5px solid #e2e2e1, 16px, 300);\n    }\n  }\n}\n\n/* To create a card at the center */\n@mixin create-card($width,\n  $height,\n  $border-radius,\n  $padding-tb,\n  $padding-lr,\n  $border,\n  $background,\n  $left) {\n  position: relative;\n  margin: auto;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: $width;\n  height: $height;\n  border-radius: $border-radius;\n  padding: $padding-tb $padding-lr;\n  border: $border;\n  background: $background;\n  text-align: center;\n}\n\n@mixin flexbox($display, $align-items, $justify-content) {\n  display: $display;\n  align-items: $align-items;\n  justify-content: $justify-content;\n}\n\n::ng-deep mat-pseudo-checkbox {\n  display: none !important;\n}\n\n::ng-deep .mat-calendar-body-selected {\n  background-color: $primary !important;\n}\n\n::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {\n  border-bottom: none !important;\n}\n\n::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {\n  border-bottom: none !important;\n}\n\n::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {\n  background-color: $primary-light !important;\n}\n\n::ng-deep .mat-form-field {\n  border: none !important;\n}\n\n.dateselect {\n  mat-form-field {\n    display: flex;\n    height: 25px;\n    width: 185px;\n    font-size: 12px;\n    text-align: center;\n    height: 24px;\n    font-family: \"Poppins\", sans-serif;\n    font-weight: 500;\n    margin-top: 7px;\n    margin-left: 8px;\n\n    mat-date-range-input {\n      ::ng-deep .mat-date-range-input-separator {\n        color: #959cbd !important;\n      }\n\n      color: #959cbd !important;\n      display: flex;\n      justify-self: center;\n    }\n\n    ::ng-deep .mat-date-range-input-content {\n      border-bottom: none !important;\n    }\n\n    mat-label {\n      font-size: 12px;\n    }\n\n    ::ng-deep mat-datepicker-toggle {\n      background-image: url(../images/calendar-icon.svg);\n      background-repeat: no-repeat;\n\n      button {\n        margin-left: 35px;\n        width: 20px !important;\n      }\n\n      .mat-mdc-icon-button svg {\n        display: none !important;\n      }\n    }\n  }\n}\n\n::ng-deep .mat-mdc-form-field-icon-suffix,\n[dir=\"rtl\"] .mat-mdc-form-field-icon-prefix {\n  width: 30px !important;\n  margin-top: 10px;\n}\n\n::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {\n  align-items: center;\n  border-radius: 5px;\n}\n\n::ng-deep .mat-mdc-icon-button {\n  --mat-icon-button-hover-state-layer-opacity: 0 !important;\n}\n\n::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {\n  display: none;\n}\n\n.tab-header {\n  ::ng-deep .mat-mdc-tab-list {\n    align-content: center;\n  }\n\n  ::ng-deep .mat-mdc-tab-links {\n    gap: 5px;\n  }\n}\n\n\n/** Date Picker **/\n\n::ng-deep mat-datepicker-toggle {\n  width: 0 !important;\n\n  button {\n    position: absolute;\n    /* margin-bottom: -20px; */\n    top: -23% !important;\n    right: 40px;\n  }\n}\n\n.date-picker {\n  height: 25px;\n  min-width: 180px;\n  font-size: 12px;\n  text-align: center;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 500;\n  margin: 7px 0;\n\n  mat-form-field {\n    width: 210px;\n  }\n\n  ::ng-deep .mdc-text-field {\n    padding-left: 0 !important;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {\n    padding: 0 !important;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex {\n    height: 23px;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {\n    width: 0 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n\n  mat-date-range-input {\n    color: #959cbd !important;\n    display: flex;\n    justify-self: center;\n\n    ::ng-deep .mat-date-range-input-separator {\n      color: #959cbd !important;\n      // margin: 0 10px;\n    }\n\n    ::ng-deep .mat-date-range-input-inner {\n      letter-spacing: 0.5px;\n    }\n\n    ::ng-deep .mat-date-range-input-container {\n      justify-content: center;\n      font-family: \"Poppins\";\n      width: fit-content;\n      margin: 0 10px;\n    }\n\n    ::ng-deep .mat-date-range-input-content {\n      border-bottom: none !important;\n    }\n\n    ::ng-deep .mat-date-range-input-end-wrapper {\n      flex-grow: initial !important;\n    }\n\n    ::ng-deep .mat-date-range-input-wrapper {\n      width: 70px;\n    }\n  }\n\n  mat-label {\n    font-size: 12px;\n  }\n\n  ::ng-deep mat-datepicker-toggle {\n    button {\n      width: 24px !important;\n      height: 24px !important;\n      padding: 0 !important;\n      transform: translateX(10px);\n      background-image: url(../images/calendar-icon.svg);\n      background-repeat: no-repeat;\n      background-position: center;\n    }\n\n    .mat-mdc-icon-button svg {\n      display: none !important;\n    }\n  }\n}\n\n/** Date Picker **/\n\n\n.back-button,\n.close-button {\n  width: 35px;\n  height: 35px;\n  background-position: center;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  transition: all .25s;\n}\n\n.back-button {\n  background-image: url('../images/back.svg');\n\n  &:hover {\n    background-image: url('../images/back-hover.svg');\n  }\n}\n\n.close-button {\n  background-image: url('../images/close-circle.svg');\n\n  &:hover {\n    background-image: url('../images/close-cirlce-hover.svg');\n  }\n}","@import \"src/assets/styles/global.scss\";\n@import \"../../users/users-layout/users-layout.component.scss\";\n\n.icon {\n  padding-right: 5px;\n}\n\n::ng-deep .mat-mdc-tab-links {\n  width: 0px;\n}\n\na:hover {\n  background-color: $primary-light !important;\n\n  ::ng-deep .mdc-tab__text-label {\n    color: $primary !important;\n  }\n}\n\n.cancel-action {\n  @include create-buttons($gray-300,\n    $gray-500,\n    0px,\n    0px,\n    100px,\n    31px,\n    13px,\n    300,\n    5px);\n  @include no-transition($gray-300, $gray-500);\n  margin-right: 10px;\n  border: none !important;\n  position: relative;\n  overflow: hidden;\n  transition: background 0.5s;\n\n  span {\n    color: $white;\n    position: relative;\n    z-index: 9;\n    padding-left: 2px;\n  }\n}\n\n.cancel-action::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to right, $gray-button, $gray-button);\n  transition: left 0.5s;\n}\n\n.cancel-action:hover::before {\n  left: 0;\n}\n\n::ng-deep .mat-mdc-tab-link.mdc-tab--active .mdc-tab__text-label {\n  color: $primary !important;\n}\n\n::ng-deep .mat-mdc-tab-link .mdc-tab__text-label:hover {\n  color: $primary !important;\n}\n\n::ng-deep .mat-mdc-tab-link .mdc-tab-indicator__content--underline {\n  border-color: $primary !important;\n}\n\n.searchText {\n  display: flex;\n  align-items: center;\n  border: 1px solid $gray-300;\n  border-radius: 5px;\n\n  input {\n    border: none;\n  }\n}\n\n.downloadUser {\n  margin-left: 120px !important;\n}\n\n.notChecked {\n  margin-left: 300px !important;\n}\n\n.searchImg {\n  width: 20px;\n  height: 15px;\n  padding-left: 5px;\n}\n\n.my-profile-container {\n  height: 100%;\n  font-family: \"Poppins\";\n  padding: 0px;\n\n  .row {\n    background-color: #ffffff;\n    padding: 30px;\n\n    .profile-container {\n      border-bottom: 1px solid #dbd8d8;\n      padding-bottom: 20px;\n\n      .profile {\n        .profile-logo {\n          float: left;\n\n          .logo {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            height: 150px;\n            width: 150px;\n            background-color: #f3f6f9;\n            font-size: 90px;\n            font-weight: 500;\n            color: #7b8fa1;\n            border-radius: 8px;\n            border: none;\n          }\n\n          ::ng-deep .mat-badge-small.mat-badge-overlap.mat-badge-after .mat-badge-content {\n            right: -8px;\n            top: 100px;\n            color: transparent;\n            background-color: $success;\n          }\n        }\n\n        .profile-info {\n          font-family: $primary-font;\n          padding-left: 30px;\n          color: $primary-grey;\n          display: flex;\n          flex-direction: column;\n          justify-content: space-around;\n          align-items: stretch;\n\n          .user-data {\n            display: flex;\n            justify-content: space-between;\n\n            .name {\n              color: $gray-800;\n              font-size: 16px;\n              font-weight: $ft-semibold;\n\n              span {\n\n                .patch-superadmin,\n                patch-SuperAdminRead {\n                  filter: invert(51%) sepia(70%) saturate(3192%) hue-rotate(196deg) brightness(105%) contrast(102%);\n                }\n\n                .patch-Vendoradmin {\n                  filter: invert(70%) sepia(60%) saturate(4215%) hue-rotate(101deg) brightness(95%) contrast(62%);\n                }\n\n                .patch-fielduser {\n                  filter: invert(66%) sepia(81%) saturate(517%) hue-rotate(6deg) brightness(102%) contrast(96%);\n                }\n\n                .patch-Site {\n                  filter: invert(66%) sepia(81%) saturate(517%) hue-rotate(6deg) brightness(102%) contrast(96%);\n                }\n\n                img {\n                  path {\n                    fill: $primary;\n                  }\n                }\n              }\n            }\n\n            .user-info {\n              display: flex;\n              gap: 10px;\n\n              .org {\n                font-size: 12px;\n              }\n\n              .phone {\n                font-size: 12px;\n              }\n\n              .fa-user {\n                margin-right: 5px;\n              }\n\n              .fa-map-marker {\n                margin-right: 5px;\n              }\n\n              .fa-phone {\n                margin-right: 5px;\n              }\n\n              .location {\n                font-size: 12px;\n              }\n            }\n          }\n\n          .count-data {\n            margin-top: 40px;\n            display: flex;\n            justify-content: space-between;\n            align-items: flex-end;\n\n            .count-info {\n              display: flex;\n\n              .onboarding-count {\n                width: 150px;\n                padding: 10px 0px;\n                text-align: center;\n                border: 1px dashed #cfcfcf;\n                border-radius: 5px;\n\n                .count {\n                  font-size: 16px;\n                  font-weight: 500;\n                  color: $dark;\n                }\n\n                .name {\n                  font-size: 12px;\n                  color: $primary-grey;\n                }\n              }\n\n              .red-flag-count {\n                margin-left: 20px;\n                width: 150px;\n                padding: 10px 0px;\n                text-align: center;\n                border: 1px dashed #cfcfcf;\n                border-radius: 5px;\n\n                .count {\n                  font-size: 16px;\n                  font-weight: 500;\n                  color: $dark;\n                }\n\n                .name {\n                  font-size: 12px;\n                  color: $primary-grey;\n                }\n              }\n            }\n\n            .progress-card {\n              width: 250px;\n              font-size: 12px;\n              box-shadow: none;\n\n              .progress-content {\n                .progress-info {\n                  display: flex;\n                  justify-content: space-between;\n\n                  .active {\n                    font-weight: 600;\n                    color: $dark !important;\n                  }\n                }\n              }\n            }\n\n            ::ng-deep mat-progress-bar {\n              --mdc-linear-progress-active-indicator-color: #3e97ff !important;\n            }\n\n            ::ng-deep .mat-mdc-progress-bar {\n              border-radius: 10px;\n            }\n          }\n        }\n      }\n    }\n\n    .tab-container {\n      nav {\n        a {\n          text-decoration: none;\n          font-family: \"Poppins\";\n\n          &:hover {\n            color: $primary !important;\n          }\n        }\n\n        .tab-active {\n          color: $primary;\n        }\n\n        ::ng-deep .mat-tab-nav-bar .mat-primary .mat-ink-bar {\n          background-color: $primary;\n        }\n      }\n\n      ::ng-deep .mat-tab-nav-bar.mat-primary .mat-ink-bar {\n        background-color: $primary;\n      }\n\n      ::ng-deep .mat-tab-body-content {\n        height: 100%;\n        overflow: hidden;\n      }\n\n      ::ng-deep .mat-tab-label {\n        font-family: \"Poppins\";\n      }\n\n      ::ng-deep .mat-tab-header {\n        border-bottom: none;\n      }\n\n      ::ng-deep .mat-tab-list .mat-tab-labels .mat-tab-label-active {\n        color: $primary;\n      }\n\n      ::ng-deep .mat-tab-group.mat-primary .mat-ink-bar {\n        background-color: $primary;\n      }\n    }\n  }\n}\n\n@media (max-width: 992px) {}\n\n@media (max-width: 769px) {\n  .my-profile-container {\n    .row {\n      .profile-container {\n        .profile {\n          .profile-info {\n            .count-data {\n              margin-top: 10px;\n              display: inline;\n\n              .progress-card {\n                display: block;\n                padding-top: 10px;\n                width: 250px;\n                font-size: 12px;\n\n                .progress-content {\n                  .progress-info {\n                    display: flex;\n                    justify-content: space-between;\n\n                    .active {\n                      font-weight: 600;\n                      color: $dark !important;\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.form-actions {\n  margin-top: 20px;\n}\n\n@media (max-width: 600px) {\n  .my-profile-container {\n    .row {\n      padding: 10px;\n\n      .profile-container {\n        .profile {\n          display: block !important;\n\n          .profile-logo {\n            float: none;\n\n            .logo {\n              margin: auto;\n              height: 100px;\n              width: 100px;\n              background-color: #f3f6f9;\n              font-size: 50px;\n              text-align: center;\n              vertical-align: middle !important;\n              font-weight: 500;\n              color: #7b8fa1;\n              border-radius: 50%;\n            }\n\n            ::ng-deep .mat-badge-small.mat-badge-overlap.mat-badge-after .mat-badge-content {\n              right: -18px;\n              top: 80px;\n              left: 70px;\n              color: transparent;\n              background-color: $success;\n            }\n          }\n\n          .profile-info {\n            margin-top: 20px;\n            padding-left: 0px;\n\n            .user-data {\n              text-align: center;\n\n              .name {\n                color: $dark;\n                font-size: 16px;\n                font-weight: bold;\n\n                img {\n                  path {\n                    fill: $primary;\n                  }\n                }\n              }\n\n              .user-info {\n                display: flex;\n                gap: 0px;\n                justify-content: space-around;\n                align-items: center;\n\n                i {\n                  display: block;\n                }\n              }\n            }\n\n            .count-data {\n              margin-top: 20px;\n              display: block;\n\n              .count-info {\n                padding-bottom: 10px;\n                justify-content: center;\n              }\n\n              .progress-card {\n                margin: auto;\n\n                .progress-content {\n                  .progress-info {\n                    display: flex;\n                    justify-content: space-between;\n\n                    .active {\n                      font-weight: 600;\n                      color: $dark !important;\n                    }\n                  }\n                }\n              }\n\n              ::ng-deep .mat-mdc-progress-bar {\n                --mdc-linear-progress-active-indicator-color: #3e97ff !important;\n              }\n\n              ::ng-deep .mat-mdc-progress-bar {\n                border-radius: 10px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 400px) {\n  .my-profile-container {\n    .row {\n      .profile-container {\n        .profile {\n          .profile-info {\n            .count-data {\n              .progress-card {\n                width: 100%;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .notChecked {\n    margin-left: 0px !important;\n    margin-top: 20px !important;\n  }\n\n  .my-profile-container .row .profile-container .profile .profile-info .user-data {\n    display: grid;\n    justify-content: center;\n  }\n\n  .downloadUser {\n    margin-top: 20px !important;\n    margin-left: 0px !important;\n  }\n\n  .form-actions {\n    margin-top: 20px !important;\n  }\n\n  .imageClass {\n    display: flex;\n    justify-content: right;\n    margin-top: 20px;\n  }\n\n  .profileCss {\n    margin-bottom: 100px;\n  }\n}\n\n@media (width: 540px) {\n  .no-gutter {\n    display: grid;\n  }\n}\n\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .notChecked {\n    margin-left: 0px !important;\n  }\n\n  .form-actions {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 20px;\n  }\n}","@import \"src/assets/styles/global.scss\";\n\n.no-margin {\n  margin-left: 0px;\n\n  mat-select {\n    padding: 3px !important;\n  }\n}\n\n.inactiveFlag {\n  padding: 0px;\n\n  form {\n    display: flex;\n    justify-content: right;\n  }\n\n  .searchText {\n    width: 210px;\n  }\n}\n\n.tab-header {\n  border-bottom: none;\n  height: 70px;\n  padding-left: 10px;\n}\n\n::ng-deep .main-content .content {\n  padding: 0px !important;\n}\n\n::ng-deep .mat-ripple .mat-mdc-tab-header-pagination .mat-mdc-tab-header-pagination-before .mat-mdc-tab-header-pagination-disabled {\n  display: none !important;\n}\n\n::ng-deep .mat-mdc-tab-header-pagination-controls-enabled .mat-mdc-tab-header-pagination {\n  display: none !important;\n}\n\n::ng-deep .mat-pseudo-checkbox-checked.mat-pseudo-checkbox-minimal::after,\n.mat-pseudo-checkbox-indeterminate.mat-pseudo-checkbox-minimal::after {\n  color: $primary;\n}\n\n::ng-deep .mdc-list-item--selected .mdc-list-item__primary-text,\n.mdc-list-item--activated .mdc-list-item__primary-text {\n  color: $primary;\n}\n\n::ng-deep .mat-mdc-select-value-text {\n  color: $gray-500;\n  font-family: $primary-font;\n  font-weight: $ft-500;\n}\n\n::ng-deep .mat-mdc-select-arrow-wrapper {\n  display: none !important;\n}\n\n.create-action {\n  font-family: $primary-font;\n  font-weight: $ft-semibold;\n  @include create-buttons($primary,\n    $white,\n    0px,\n    0px,\n    100px,\n    31px,\n    13px,\n    300,\n    5px);\n  @include no-transition($primary, $white);\n  margin: 0px 7px !important;\n  border: none !important;\n  position: relative;\n  overflow: hidden;\n  transition: background 0.5s;\n\n  span {\n    color: $white;\n    position: relative;\n    z-index: 10000;\n    padding-left: 2px;\n  }\n\n  img {\n    // margin-left: 7px;\n    position: relative;\n    z-index: 10000;\n    margin-bottom: 3px;\n    width: 12px;\n  }\n}\n\n.create-action::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to right, $gray-button, $gray-button);\n  transition: left 0.5s;\n}\n\n.create-action:hover::before {\n  left: 0;\n}\n\n// .flexclass {\n::ng-deep .mat-mdc-tab-header.mat-mdc-tab-nav-bar-stretch-tabs .mat-mdc-tab-link {\n  flex-grow: 0 !important;\n}\n\n.tab-header {\n  ::ng-deep .mat-mdc-tab-link {\n    padding: 0 10px;\n  }\n}\n\n// }\n.topClass {\n  position: fixed;\n  z-index: 10;\n  top: 80px;\n  min-height: 40px;\n  width: 100%;\n}\n\n.download {\n  margin-left: 8px !important;\n}\n\n.allFlags {\n  width: 24px;\n  margin-left: -3px;\n}\n\n.siteClass {\n  margin-left: 10px !important;\n}\n\n.layout-header {\n  background-color: $white;\n  overflow-y: hidden;\n  margin: 0px !important;\n  overflow-x: hidden;\n}\n\n.layout {\n  margin: 20px;\n  margin-top: 60px;\n  background: $white;\n  gap: 12px\n}\n\n.head {\n  color: $black;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 0 20px;\n  margin: 10px 0;\n}\n\n.vertical-line {\n  border-right: 1px solid gainsboro;\n}\n\n.right-header {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0 20px;\n}\n\n.rightDiv {\n  display: flex;\n  gap: 8px;\n}\n\n.selectClass {\n  font-size: 12px !important;\n  margin: 7px 0px;\n  // background-repeat: no-repeat;\n  // background-position-x: 96%;\n  // background-position-y: center;\n  background-color: $primary-light;\n  border-radius: 5px;\n  width: 140px;\n  text-align: center;\n}\n\n.report {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: $primary-light;\n  border-radius: 5px;\n  height: 25.5px;\n  text-align: center;\n  padding: 0 20px;\n  margin: 7px 0;\n\n  p {\n    font-size: 12px;\n    color: $gray-500;\n    text-align: center;\n\n  }\n\n  div {\n    width: 18px;\n    height: 18px;\n    background-image: url(\"../../../../assets/images/report-download.svg\");\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n\n\n}\n\n.tabs {\n  background-color: $white;\n  margin: 20px;\n  margin-top: 60px;\n  margin-left: 20px !important;\n  margin-right: 20px !important;\n  padding: 10px;\n  margin-bottom: 70px;\n}\n\n.headerTab {\n  padding: 20px;\n  padding-top: 0px;\n}\n\n::ng-deep .mdc-tab__text-label {\n  font-size: 16px !important;\n  letter-spacing: 0px;\n  color: $dark !important;\n  font-family: $primary-font;\n}\n\n.tab-label {\n  &:hover {\n    color: $primary;\n  }\n}\n\n.tab-active {\n  .tab-label {\n    color: $primary;\n  }\n\n  border-bottom: 2px solid $primary;\n}\n\n.redFlag {\n  .tab-label {\n    color: $primary;\n  }\n\n  color: $primary;\n  border-bottom: 2px solid $primary;\n}\n\n.toolbar {\n  mat-toolbar-row {\n    padding: 0px;\n  }\n\n  nav {\n    a {\n      padding: 0px 8px;\n    }\n\n    .history {\n      margin-left: 4px;\n    }\n  }\n\n  background-color: $white;\n}\n\n\n.searchText {\n  display: flex;\n  align-items: center;\n  border: 1px solid $gray-300;\n  border-radius: 5px;\n\n  input {\n    border: none;\n  }\n}\n\n.searchImg {\n  width: 20px;\n  height: 15px;\n  padding-left: 5px;\n}\n\n.searchFlag {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  position: relative;\n\n  .search {\n    width: 30%;\n\n    .searchText {\n\n      input,\n      input::placeholder {\n        font-size: 12px;\n        color: $gray-500;\n        font-family: \"Poppins\";\n      }\n\n      input {\n        border-color: $gray-200;\n        box-shadow: none !important;\n      }\n    }\n  }\n\n  .flag {\n    display: grid;\n    justify-content: left;\n    margin-left: 18px;\n  }\n}\n\n::ng-deep .mat-mdc-option .mat-pseudo-checkbox-minimal {\n  width: 6px !important;\n}\n\n.logClass {\n  font-size: 12px !important;\n  padding: 5px 10px !important;\n  width: 220px;\n  text-align: center;\n  background-repeat: no-repeat;\n  background-position: calc(100% + -3px), calc(0% + 8px);\n  background-size: 18px;\n  background-color: $primary-light;\n  border: none;\n  color: $gray-500;\n  box-shadow: none !important;\n  border-radius: 5px;\n}\n\n.flagClass {\n  font-size: 12px !important;\n  padding: 5px 0px !important;\n  width: 150px;\n  text-align: center;\n  // background-size: 25px !important;\n  // background-image: url(\"../../../../assets/images/flag-dropdown.svg\"),url(\"../../../../assets/images/flag.svg\");\n  background-repeat: no-repeat;\n  // background-position: right, left;\n  background-position: calc(100% + -3px), calc(0% + 8px);\n  background-size: 18px;\n  background-color: $primary-light;\n  border: none;\n  color: $gray-500;\n  box-shadow: none !important;\n  border-radius: 5px;\n}\n\n.option {\n  font-size: 12px !important;\n  padding-left: 10px;\n  font-family: $primary-font;\n  font-weight: $ft-500;\n\n  &:active {\n    color: $primary !important;\n  }\n\n  &:hover {\n    color: $primary;\n  }\n\n  span {\n    padding-left: 8px;\n  }\n\n  img {\n    width: 17px;\n  }\n}\n\n.redflagClass {\n  font-size: 12px !important;\n  padding: 10px 12px !important;\n  text-align: center;\n  background-size: 25px 15px !important;\n  --bs-form-select-bg-img: url(\"../../../../assets/images/flag-dropdown.svg\"),\n    url(\"../../../../assets/images/flag-red.svg\");\n  background-position: right, left;\n  background-size: 30px;\n  background-color: $primary-light;\n  border: none;\n  color: $gray-500;\n  box-shadow: none !important;\n}\n\n::ng-deep .mat-mdc-form-field-subscript-wrapper {\n  display: none !important;\n}\n\n.mat-icon {\n  height: 30px;\n\n  img {\n    width: 17px;\n  }\n}\n\n.custom-mat-form-field {\n  width: 50%;\n  height: 50px;\n}\n\n.input {\n  height: 50%;\n  margin: 7px 0px;\n  width: 120px;\n  background: $primary-light;\n  border: none;\n  font-size: 12px;\n  color: $gray-500;\n  border-radius: 5px;\n\n  &:focus {\n    outline: none;\n  }\n}\n\n.input::placeholder {\n  color: $gray-500;\n  padding-left: 10px;\n}\n\n::ng-deep .ngx-pagination li {\n  font-family: $primary-font;\n  font-weight: $ft-500;\n  border-radius: 5px !important;\n  margin: 0px 15px;\n\n  a {\n    color: $gray-500 !important;\n  }\n}\n\n::ng-deep .ngx-pagination li :hover {\n  border-radius: 5px !important;\n  color: $white !important;\n  background-color: $primary !important;\n}\n\n::ng-deep .ngx-pagination li:not(:last-child) {\n  background-color: $gray-200 !important;\n}\n\n::ng-deep .ngx-pagination li.current {\n  font-family: $primary-font;\n  font-weight: $ft-500;\n  background-color: $primary !important;\n  color: $white !important;\n  cursor: pointer;\n}\n\n.date-pickder {\n  height: 25px;\n}\n\n.dateClass {\n  width: 180px;\n  font-size: 12px;\n  text-align: center;\n  height: 24px;\n  color: $gray-500;\n  font-family: $primary-font;\n  font-weight: $ft-500;\n  margin-top: 7px;\n  background-image: url(\"../../../../assets/images/calendar-icon.svg\");\n  background-repeat: no-repeat;\n  background-position: 155px;\n  background-color: $primary-light;\n  cursor: pointer;\n  border: none;\n  outline: none;\n  border-radius: 5px;\n  padding-right: 25px;\n  margin-left: 8px;\n}\n\n::ng-deep .mat-form-field-type-mat-date-range-input .mat-form-field-infix {\n  display: flex;\n}\n\n::ng-deep .mat-date-range-input-start-wrapper {\n  width: 32%;\n}\n\n::ng-deep .md-drppicker.ltr {\n  // left: 0px !important;\n  position: fixed;\n  color: $dark;\n  padding: 10px;\n}\n\n::ng-deep .md-drppicker .ranges ul li button.active {\n  background-color: $primary !important;\n  border-radius: 5px;\n}\n\n::ng-deep .md-drppicker td.active,\n.md-drppicker td.active:hover {\n  background-color: $primary !important;\n}\n\n::ng-deep .md-drppicker .calendar th span,\n.md-drppicker .calendar td span {\n  color: $dark !important;\n}\n\n::ng-deep .md-drppicker th.month {\n  color: $dark;\n}\n\n::ng-deep .buttons_input {\n  .btn {\n    background-color: $primary !important;\n  }\n\n  .btn-default {\n    background-color: #dcdcdc !important;\n    margin-right: 15px;\n  }\n}\n\n.myDatePicker {\n  ::ng-deep ngx-daterangepicker-material .md-drppicker {\n    height: 300px;\n    overflow: auto;\n    top: 125px !important;\n\n    .ranges {\n      ul {\n        li {\n          border-radius: 5px;\n\n          &:hover {\n            background-color: $primary;\n          }\n\n          button {\n            &:hover {\n              color: $white;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n::ng-deep .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled) .mdc-list-item__primary-text {\n  color: $primary !important;\n  font-family: $primary-font;\n  font-weight: $ft-500;\n}\n\n::ng-deep .mat-mdc-option .mat-pseudo-checkbox-minimal {\n  margin: 0px !important;\n}\n\n::ng-deep .mat-mdc-tab-link-container {\n  overflow: auto !important;\n}\n\n.tab-navbar {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n@media (max-width: 1024px) {\n  .tab-navbar {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 540px) {\n  .rightDiv {\n    overflow-x: auto;\n  }\n\n  .search {\n    width: 100% !important;\n  }\n\n  ::ng-deep ngx-daterangepicker-material .md-drppicker {\n    left: 60px !important;\n    top: 160px !important;\n  }\n}\n\n@media (width: 540px) {\n  ::ng-deep ngx-daterangepicker-material .md-drppicker {\n    left: 200px !important;\n  }\n\n  .rightHeader {\n    justify-content: center !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .layout {\n    margin-top: 95px;\n  }\n  .right-header {\n    padding: 0 10px;\n  }\n}\n\n@media (max-width: 290px) {\n  .toolbar {\n    overflow-x: auto;\n  }\n\n  .searchFlag {\n    display: block;\n  }\n\n  .search {\n    padding: 15px 0px;\n  }\n\n  .flag {\n    display: block !important;\n    text-align: right;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 830px) {\n  .rightDiv {\n    overflow-x: auto;\n  }\n}\n\n@media (min-width: 700px) {\n  ::ng-deep ngx-daterangepicker-material .md-drppicker {\n    left: calc(100% - 630px) !important;\n  }\n}\n\n@media (width: 280px) {\n  ::ng-deep ngx-daterangepicker-material .md-drppicker {\n    left: 9px !important;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  ::ng-deep .mat-mdc-tab-link-container {\n    overflow: auto !important;\n  }\n\n  ::ng-deep .mat-mdc-tab-nav-bar {\n    width: 100% !important;\n  }\n}","@import \"src/assets/styles/global.scss\";\n@import \"../../associates/associate-layout-v2/associate-layout-v2.component.scss\";\n\n.tabs {\n  background-color: $white;\n  margin: 20px;\n  margin-left: 20px !important;\n  margin-right: 20px !important;\n  padding: 10px;\n}\n\n.searchText {\n  display: flex;\n  align-items: center;\n  border: 1px solid $gray-300;\n  border-radius: 5px;\n\n  input {\n    border: none;\n  }\n}\n\n.searchImg {\n  width: 20px;\n  height: 15px;\n  padding-left: 5px;\n}\n\n.hideButton {\n  z-index: -1;\n}\n\n::ng-deep .mat-mdc-menu-content,\n.mat-mdc-menu-content .mat-mdc-menu-item .mat-mdc-menu-item-text {\n  :hover {\n    color: $primary !important;\n    background-color: $primary-light;\n  }\n}\n\n::ng-deep .mdc-tab__text-label {\n  font-size: 16px !important;\n  letter-spacing: 0px;\n  color: $dark !important;\n  font-family: $primary-font;\n}\n\n.tab-label {\n  &:hover {\n    color: $primary;\n  }\n}\n\n.topClass {\n  position: fixed;\n  z-index: 10;\n  top: 80px;\n  width: 100%;\n}\n\n.layout-header {\n  display: flex;\n  justify-content: space-between;\n  background-color: $white;\n  overflow-y: hidden;\n  margin: 0px !important;\n  overflow-x: hidden;\n\n  .back-icon {\n    margin-top: 12px;\n    margin-left: 10px;\n  }\n}\n\n.tab-header {\n  border-bottom: none;\n  height: 70px;\n  padding-left: 10px;\n\n  a {\n    padding: 0px;\n    width: 0px;\n    text-decoration: none;\n\n    &:hover {\n      color: $primary;\n    }\n  }\n\n  .tab-active {\n    .tab-label {\n      color: $primary;\n    }\n\n    border-bottom: 2px solid $primary;\n  }\n\n  .mat-tab-link {\n    min-width: 110px !important;\n    margin-top: 10px;\n    padding: 0;\n    font-size: 18px;\n    font-weight: $ft-bold;\n    opacity: 0.5;\n  }\n}\n\n.layout-panel {\n  height: calc(100vh - 170px);\n  overflow: auto;\n\n  >div {\n    margin: 20px;\n    padding: 0 10px;\n    background: $white;\n  }\n\n  @media (max-width: 576px) {\n    height: calc(100vh - 207px);\n  }\n}\n\n.tab-body {\n  top: 20px;\n}\n\n.material-icons {\n  vertical-align: middle;\n  margin-left: 25px;\n  font-size: 30px;\n}\n\n.create-action {\n  font-family: $primary-font;\n  font-weight: $ft-semibold;\n  @include create-buttons($primary,\n    $white,\n    0px,\n    0px,\n    100px,\n    31px,\n    13px,\n    300,\n    5px);\n  @include no-transition($primary, $white);\n  border: none !important;\n  position: relative;\n  overflow: hidden;\n  transition: background 0.5s;\n  margin: 0px !important;\n\n  span {\n    color: $white;\n    position: relative;\n    z-index: 9;\n    padding-left: 2px;\n  }\n\n  img {\n    margin-left: 0px !important;\n    width: 12px;\n    margin-bottom: 1px !important;\n    z-index: 9;\n    position: relative;\n  }\n}\n\n.create-action::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to right, $gray-button, $gray-button);\n  transition: left 0.5s;\n}\n\n.create-action:hover::before {\n  left: 0;\n}\n\n.delete-action {\n  width: 100%;\n  background: $danger;\n\n  img {\n    width: 15px;\n    height: 15px;\n    transform: translateY(-1.5px);\n    margin: 0;\n  }\n\n  @include no-transition($danger, $white);\n}\n\n.deletecount {\n  width: 100%;\n  text-align: center;\n  color: $danger;\n  background-color: $danger-light;\n  padding: 6px 12px;\n  border-radius: 5px;\n  font-family: $primary-font;\n  font-weight: 500;\n  font-size: 13px;\n}\n\n.searchFlag {\n  gap: 12px;\n  padding-right: 10px;\n}\n\n.search {\n  width: 100% !important;\n}\n\n.buttonsClass {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n\n.rightHeader {\n  justify-content: flex-end;\n}\n\n.vendor {\n  margin-right: 7px;\n}\n\n@media (max-width: 768px) {\n  .layout {\n    margin-top: 95px !important;\n  }\n}\n\n@media (max-width: 560px) {\n  .layout-header {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 452px) {\n  .searchFlag {\n    flex-direction: column;\n  }\n\n  .buttonsClass,\n  .create-action {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
